/**
 * English translations
 * Coláiste Lurgan Management System
 */

const enTranslations = {
// Auth & Login
"app.title": "Coláiste Lurgan",
"app.subtitle": "Student Management System",
"login.title": "Coláiste Lurgan",
"login.subtitle": "Management System",
"login.username": "Username",
"login.password": "Password",
"login.submit": "Login",
"login.loggingIn": "Logging in...",
"login.trouble": "Having trouble?",
"login.contact": "Contact administration",
"login.show": "Show",
"login.hide": "Hide",
"login.errors.required": "This field is required",
"login.errors.username": "Username required",
"login.errors.password": "Password required",
"login.errors.network": "Network error. Please check your connection.",
"login.errors.unauthorized": "Invalid username or password",
"login.errors.generic": "An unexpected error occurred. Please try again.",
"login.forgotPassword": "Forgot password?",
"login.rememberMe": "Remember me for 7 days",

// Forgot Password
"forgotPassword.title": "Reset Password",
"forgotPassword.description": "Enter your email address and we'll send you a link to reset your password.",
"forgotPassword.emailLabel": "Email Address",
"forgotPassword.submit": "Send Reset Link",
"forgotPassword.successTitle": "Check Your Email",
"forgotPassword.successDesc": "If an account with that email exists, a password reset link has been sent. Check your inbox.",
"forgotPassword.backToLogin": "Back to login",

// Reset Password
"resetPassword.title": "Set New Password",
"resetPassword.description": "Enter your new password below.",
"resetPassword.newPassword": "New Password",
"resetPassword.confirmPassword": "Confirm Password",
"resetPassword.submit": "Reset Password",
"resetPassword.successTitle": "Password Reset",
"resetPassword.successDesc": "Your password has been reset successfully. Redirecting to login...",
"resetPassword.invalidToken": "Invalid Reset Link",
"resetPassword.invalidTokenDesc": "This password reset link is invalid or has expired. Please request a new one.",

// MFA
"mfa.title": "Verify Your Identity",
"mfa.instruction": "Enter the 6-digit code sent to your email address",
"mfa.codeLabel": "Login Code",
"mfa.verify": "Verify",
"mfa.verifying": "Verifying...",
"mfa.resend": "Resend code",
"mfa.resending": "Resending...",
"mfa.errors.invalidCode": "Please enter a 6-digit code",
"mfa.errors.failed": "Incorrect or expired code. Please try again.",
"mfa.errors.resendFailed": "Failed to resend code. Please try again.",

// Profile
"profile.title": "My Profile",
"profile.description": "Manage your account settings and preferences",
"profile.personal.title": "Personal Information",
"profile.personal.description": "Update your name and contact details",
"profile.username": "Username",
"profile.usernameNote": "Your username cannot be changed",
"profile.firstName": "First Name",
"profile.lastName": "Last Name",
"profile.email": "Email Address",
"profile.verified": "Verified",
"profile.unverified": "Unverified",
"profile.editProfile": "Edit Profile",
"profile.phoneNumber": "Phone Number",
"profile.phoneRequired": "Required for parent accounts",
"profile.parentSyncNote": "Updating your name, phone, or email will also update your child's records.",
"profile.security.title": "Security",
"profile.security.description": "Manage your password and account security",
"profile.password": "Password",
"profile.passwordNote": "Keep your account secure with a strong password",
"profile.changePassword": "Change Password",
"profile.passwordChangeDescription": "Enter your current password and choose a new one",
"profile.currentPassword": "Current Password",
"profile.newPassword": "New Password",
"profile.confirmPassword": "Confirm Password",
"profile.updatePassword": "Update Password",
"profile.twoFactor": "Two-Factor Authentication",
"profile.twoFactorNote": "Login codes are sent to your email on every sign-in",
"profile.enable": "Enabled",
"profile.language": "Language",
"profile.languageNote": "Choose your preferred interface language",
"profile.languageSwitchHint": "Use the language button in the top navigation bar to switch language.",
"profile.appearance": "Appearance",
"profile.appearanceNote": "Choose your preferred colour scheme",
"profile.theme.light": "Light",
"profile.theme.dark": "Dark",
"profile.theme.system": "System",
"profile.changeEmail": "Change Email Address",
"profile.newEmail": "New Email Address",
"profile.emailChangeWarning": "A verification email will be sent to your new address. Your current email stays active until verified.",
"profile.emailChangeSent": "Verification email sent to {{email}}. Check your inbox.",
"profile.emailChangeFailed": "Failed to send verification email. Please try again.",
"profile.toast.profileUpdated": "Profile updated",
"profile.toast.profileUpdatedDesc": "Your profile has been saved successfully",
"profile.toast.updateFailed": "Update failed",
"profile.toast.updateFailedDesc": "Could not save your profile changes",
"profile.toast.passwordMismatch": "Passwords don't match",
"profile.toast.passwordMismatchDesc": "Please make sure both password fields match",
"profile.toast.passwordTooShort": "Password too short",
"profile.toast.passwordTooShortDesc": "Password must be at least 8 characters long",
"profile.toast.passwordUpdated": "Password updated",
"profile.toast.passwordUpdatedDesc": "Your password has been changed successfully",
"profile.toast.passwordChangeFailed": "Password change failed",
"profile.toast.passwordChangeFailedDesc": "Could not change your password. Please try again.",
"profile.toast.themeUpdated": "Theme updated",
"profile.toast.themeUpdatedDesc": "Switched to {{theme}} mode",
"profile.preferences": "Preferences",
"profile.preferencesNote": "Language and display settings",
"profile.unsavedChanges": "Unsaved changes",
"profile.changeEmailShort": "Change",
"profile.saveAndSend": "Save & Send",
"profile.twoFactorActive": "Email Active",
"profile.twoFactorAppComingSoon": "App-based 2FA coming soon",
"profile.passwordStrength.weak": "Weak",
"profile.passwordStrength.fair": "Fair",
"profile.passwordStrength.good": "Good",
"profile.passwordStrength.strong": "Strong",
"common.send": "Send",

// My Student Detail (parent view)
"myStudent.back": "Family Dashboard",
"myStudent.personalDetails": "Personal Details",
"myStudent.placement": "Placement",
"myStudent.attendanceHistory": "Attendance History",
"myStudent.saveSuccess": "has been updated successfully.",
"myStudent.saveError": "Failed to save changes. Please try again.",
"myStudent.missingEmailBanner": "Your child's email address is missing. They will need it to access Oide, the online learning platform.",
"myStudent.addEmail": "Add Email",
"myStudent.missingPhoneBanner": "Your parent/guardian phone number is missing. Please add it so the college can reach you if needed.",
"myStudent.addPhone": "Add Phone",
"myStudent.missingAddressBanner": "Your child's address and travel details are missing. Please add them before the course begins.",
"myStudent.addDetails": "Add Details",
"myStudent.pastStudentBanner": "This is a past enrolment. The record is read-only and kept for your reference.",

// Family Dashboard
"familyDashboard.title": "Family Dashboard",
"familyDashboard.description": "View your children's details and payment information.",
"familyDashboard.myChildren": "My Children",
"familyDashboard.noChildren": "No students found linked to your account. Please contact the college.",
"familyDashboard.viewAndEdit": "View & Edit",
"familyDashboard.viewDetails": "View Details",
"familyDashboard.cancelled": "Cancelled",
"familyDashboard.paid": "Paid",
"familyDashboard.balance": "Balance due",
"familyDashboard.pastStudent": "Past Student",
"familyDashboard.pastStudents": "Past Students",

// Email Verification
"verifyEmail.title": "Set Your Password",
"verifyEmail.subtitle": "Please create a secure password for your account",
"verifyEmail.password": "Password",
"verifyEmail.confirmPassword": "Confirm Password",
"verifyEmail.passwordPlaceholder": "Enter your password",
"verifyEmail.confirmPasswordPlaceholder": "Confirm your password",
"verifyEmail.passwordRequirements": "At least 12 characters with uppercase, lowercase, number, and special character",
"verifyEmail.req.length": "At least 12 characters",
"verifyEmail.req.upper": "One uppercase letter (A–Z)",
"verifyEmail.req.lower": "One lowercase letter (a–z)",
"verifyEmail.req.number": "One number (0–9)",
"verifyEmail.req.special": "One special character (!@#$%^&*)",
"verifyEmail.submit": "Set Password and Verify",
"verifyEmail.submitting": "Setting Password...",
"verifyEmail.show": "Show",
"verifyEmail.hide": "Hide",
"verifyEmail.backToLogin": "Back to Login",
"verifyEmail.goToLogin": "Go to Login",
"verifyEmail.invalidLink": "Invalid Verification Link",
"verifyEmail.success.title": "Email Verified",
"verifyEmail.success.description": "Your email has been verified successfully. You can now log in.",
"verifyEmail.errors.noToken": "No verification token found in URL",
"verifyEmail.errors.tokenInvalid": "This link is no longer valid. Please contact the college to get a new one.",
"verifyEmail.errors.passwordMin": "Password must be at least 12 characters",
"verifyEmail.errors.passwordSpecial": "Password must contain at least one special character (!@#$%^&*)",
"verifyEmail.errors.passwordUppercase": "Password must contain at least one uppercase letter",
"verifyEmail.errors.passwordLowercase": "Password must contain at least one lowercase letter",
"verifyEmail.errors.passwordNumber": "Password must contain at least one number",
"verifyEmail.errors.confirmRequired": "Please confirm your password",
"verifyEmail.errors.passwordMatch": "Passwords do not match",
"verifyEmail.errors.default": "Verification failed. Please try again.",

// Navigation & Layout
"nav.dashboard": "Dashboard",
"nav.students": "Students", 
"nav.courses": "Courses",
"nav.houses": "Houses",
"nav.classes": "Classes",
"nav.payments": "Payments",
"nav.communications": "Communications",
"nav.travel": "Travel",
"nav.settings": "Settings",
"nav.auditLog": "Audit Log",
"nav.profile": "Profile",
"nav.familyDashboard": "Family Dashboard",
"nav.help": "Help",
"nav.logout": "Logout",
"nav.loggingOut": "Logging out...",

// User Types
"userType.ADMIN": "Administrator",
"userType.TEACHER": "Teacher",
"userType.OFFICE": "Office Staff",
"userType.HOUSE_OWNER": "House Owner",
"userType.INTERVIEWER": "Interviewer",
"userType.PARENT": "Parent",
"userType.label": "User Type",

// Dashboard
"dashboard.courseOverview": "Course Overview",
"dashboard.welcome.ADMIN": "Welcome back, Administrator!",
"dashboard.welcome.TEACHER": "Welcome back, Teacher!",
"dashboard.welcome.OFFICE": "Welcome back, Office Staff!",
"dashboard.welcome.HOUSE_OWNER": "Welcome back, House Owner!",
"dashboard.welcome.INTERVIEWER": "Welcome back, Interviewer!",
"dashboard.welcome.PARENT": "Welcome back, Parent!",
"dashboard.subtitle": "Analytics for upcoming courses",

// Dashboard Cards
"dashboard.students": "Students",
"dashboard.activeCourses": "Active Courses",
"dashboard.houses": "Houses",
"dashboard.classes": "Classes",
"dashboard.pendingPayments": "Pending Payments",
"dashboard.systemPerformance": "System Performance",
"dashboard.quickActions": "Quick Actions",
"dashboard.systemStatus": "System Status",
"dashboard.yourInformation": "Your Information",

// Dashboard Stats
"dashboard.newThisWeek": "new this week",
"dashboard.currentSeason": "for current season",
"dashboard.available": "available",
"dashboard.organized": "organized",
"dashboard.awaitingProcessing": "awaiting processing",

// Dashboard Analytics
"dashboard.clearFilter": "Clear Filter",
"dashboard.totalStudents": "Total Students",
"dashboard.totalWithCinnire": "Total with Cinnirí",
"dashboard.withCinnire": "With Cinnirí",
"dashboard.cancelled": "Cancelled",
"dashboard.registered": "Registered for upcoming courses",
"dashboard.upcoming": "Upcoming sessions",
"dashboard.genderSplit": "Gender Split",
"dashboard.countyReach": "County Reach",
"dashboard.countiesRepresented": "Counties represented",
"dashboard.courseEnrollment": "Enrollment by Course",
"dashboard.genderByCourse": "Gender Distribution by Course",
"dashboard.schoolYears": "School Year Breakdown",
"dashboard.total": "Total",
"dashboard.topCounties": "Top Counties",
"dashboard.travelLocations": "Travel Locations",
"dashboard.studentsRequireTravel": "students require travel",
"dashboard.courseDetails": "Course Details",
"dashboard.courseName": "Course Name",
"dashboard.dates": "Dates",
"dashboard.capacity": "Capacity",
"dashboard.male": "Male",
"dashboard.female": "Female",
"dashboard.cinnire": "Cinnire (Leaders)",
"dashboard.cinnireNote": "(Included in total above)",
"dashboard.travel": "Travel",
"dashboard.showing": "Showing top 10 of",
"dashboard.counties": "counties",
"dashboard.clickToFilter": "Click a bar to filter data",
"dashboard.uptime": "uptime",
"dashboard.allCourses": "All Courses",
"dashboard.viewDetails": "View details",
"dashboard.noCourses": "No upcoming courses",
"dashboard.noCoursesAllTime": "No courses found",
"courseFilter.upcoming": "Upcoming",
"courseFilter.allTime": "All Time",
"courseFilter.ended": "Ended",
"dashboard.interviews": "Interviews",
"dashboard.placement": "Housing",
"dashboard.unassigned": "Unassigned",
"dashboard.payments": "Payments",
"dashboard.fullyPaid": "Fully Paid",
"dashboard.outstanding": "Outstanding",
"dashboard.noPayment": "No Payment",

// Interviewer Dashboard
"interviewDashboard.title": "Interview Overview",
"interviewDashboard.subtitle": "Your interview progress across courses",
"interviewDashboard.totalPending": "Total Pending",
"interviewDashboard.pendingCourses": "Pending Courses",
"interviewDashboard.myAvgScore": "My Avg Score",
"interviewDashboard.interviews": "Interviews",
"interviewDashboard.pending": "Pending",
"interviewDashboard.scored": "Scored",
"interviewDashboard.notRequired": "Not Required",
"interviewDashboard.myScores": "My Scores",
"interviewDashboard.completed": "Completed",
"interviewDashboard.avgScore": "Avg Score",
"interviewDashboard.noCourses": "No upcoming courses",
"interviewDashboard.noCoursesDescription": "There are no active courses with students to interview.",

// Quick Actions
"dashboard.addNewStudent": "Add new student",
"dashboard.manageCourses": "Manage courses",
"dashboard.assignHouses": "Assign houses",

// System Status
"dashboard.database": "Database",
"dashboard.apiServices": "API Services", 
"dashboard.emailService": "Email Service",
"dashboard.backups": "Backups",
"dashboard.status.active": "Active",
"dashboard.status.slow": "Slow",
"dashboard.status.successful": "Successful",

// User Information
"dashboard.name": "Name",
"dashboard.email": "Email",
"dashboard.loggedIn": "Logged In",

// Access Control
"access.denied": "Access Denied",
"access.noPermission": "You don't have permission to view this page.",
"access.goBack": "Go Back",
"access.permissionsRequired": "Permissions Required",
"access.noPermissionAction": "You don't have the required permissions for this action.",

// Loading States
"loading.text": "Loading...",
"common.back": "Back",
"common.loading": "Loading...",
"common.errorLoading": "An error occurred while loading. Please try again.",
"common.processing": "Processing...",
"loading.tip": "Please be patient, the system is starting up...",

// Pagination
"pagination.showing": "Showing {{from}} to {{to}} of {{total}} results",
"pagination.previous": "Previous",
"pagination.next": "Next",
"pagination.pageOf": "Page {{current}} of {{total}}",
"pagination.show": "Show",
"pagination.perPage": "per page",

// Coming Soon
"comingSoon": "Coming Soon",

// General
"language": "Language",
"save": "Save",
"cancel": "Cancel",
"reset": "Reset",
"edit": "Edit",
"delete": "Delete",
"create": "Create",
"update": "Update",
"search": "Search",
"filter": "Filter",
"all": "All",
"active": "Active",
"inactive": "Inactive",
"yes": "Yes",
"no": "No",

// Status Labels
"status.enrolled": "Enrolled",
"status.waitlist": "Waitlist",
"status.cancelled": "Cancelled",

// Payment Status
"paymentStatus.outstanding": "Outstanding",

// Settings & Permissions
"settings.title": "Settings",
"settings.description": "Manage system settings and configurations",
"settings.tabs.profile": "Profile",
"settings.tabs.users": "Users",
"settings.tabs.permissions": "Permissions",
"settings.tabs.system": "System",
"settings.tabs.schoolData": "School Data",
"settings.tabs.fieldPermissions": "Field Permissions",

// Field Permissions
"settings.permissions.title": "Field Permissions",
"settings.permissions.description": "Configure which fields each user role can view and edit",
"settings.permissions.saveChanges": "Save Changes",
"settings.permissions.saveSuccess": "Permissions updated successfully",
"settings.permissions.saveError": "Failed to save permissions",
"settings.permissions.noChanges": "No changes to save",
"settings.permissions.unsavedChanges": "{{count}} unsaved change",
"settings.permissions.unsavedChanges_other": "{{count}} unsaved changes",
"settings.permissions.changesCancelled": "Changes cancelled",
"settings.permissions.confirmTitle": "Confirm Permission Changes",
"settings.permissions.confirmDescription": "You are about to modify {{count}} permission(s). These changes will take effect immediately.",
"settings.permissions.confirmChanges": "Confirm Changes",
"settings.permissions.auditLog": "Recent Changes",
"settings.permissions.noAuditLogs": "No recent changes",
"settings.permissions.fieldColumn": "Field",
"settings.permissions.viewLabel": "View",
"settings.permissions.editLabel": "Edit",

// Field Permissions - Roles
"settings.permissions.roles.TEACHER": "Teacher",
"settings.permissions.roles.INTERVIEWER": "Interviewer",
"settings.permissions.roles.HOUSE_OWNER": "House Owner",
"settings.permissions.roles.PARENT": "Parent",
"settings.permissions.roles.OFFICE": "Office",

// Field Permissions - Categories
"settings.permissions.categories.Administrative": "Administrative",
"settings.permissions.categories.Personal": "Personal",
"settings.permissions.categories.Contact": "Contact",
"settings.permissions.categories.Address": "Address",
"settings.permissions.categories.Academic": "Academic",
"settings.permissions.categories.Travel": "Travel",
"settings.permissions.categories.Leadership": "Leadership",
"settings.permissions.categories.Friendship": "Friendship",
"settings.permissions.categories.Financial": "Financial",
"settings.permissions.categories.Notes": "Notes",

// Field Permissions - Field Names
"settings.permissions.fields.student_id": "Student ID",
"settings.permissions.fields.status": "Status",
"settings.permissions.fields.upload_status": "Upload Status",
"settings.permissions.fields.upload_issues": "Upload Issues",
"settings.permissions.fields.photo_url": "Photo",
"settings.permissions.fields.first_name": "First Name",
"settings.permissions.fields.last_name": "Last Name",
"settings.permissions.fields.birthday": "Date of Birth",
"settings.permissions.fields.age": "Age",
"settings.permissions.fields.gender": "Gender",
"settings.permissions.fields.home_county": "Home County",
"settings.permissions.fields.parent_name": "Parent/Guardian Name",
"settings.permissions.fields.parent_email": "Parent/Guardian Email",
"settings.permissions.fields.parent_phone": "Parent/Guardian Phone",
"settings.permissions.fields.student_email": "Student Email",
"settings.permissions.fields.address_1": "Address Line 1",
"settings.permissions.fields.address_2": "Address Line 2",
"settings.permissions.fields.address_3": "Address Line 3",
"settings.permissions.fields.address_4": "Address Line 4",
"settings.permissions.fields.eircode": "Eircode",
"settings.permissions.fields.course": "Course",
"settings.permissions.fields.house": "House",
"settings.permissions.fields.class_group": "Class Group",
"settings.permissions.fields.school": "School",
"settings.permissions.fields.school_year": "School Year",
"settings.permissions.fields.interview_score": "Interview Score",
"settings.permissions.fields.interview_notes": "Interview Notes",
"settings.permissions.fields.attended_before": "Attended Before",
"settings.permissions.fields.when_attended": "When Attended",
"settings.permissions.fields.travel_required": "Travel Required",
"settings.permissions.fields.travel_location": "Travel Location",
"settings.permissions.fields.is_cinnire": "Cinnire (Leader)",
"settings.permissions.fields.oide_username": "Assigned Oide",
"settings.permissions.fields.total_paid": "Total Paid",
"settings.permissions.fields.balance_due": "Balance Due",
"settings.permissions.fields.has_friends": "Has Friends",
"settings.permissions.fields.friend_1_id": "Friend 1 ID",
"settings.permissions.fields.friend_1_name": "Friend 1 Name",
"settings.permissions.fields.friend_2_id": "Friend 2 ID",
"settings.permissions.fields.friend_2_name": "Friend 2 Name",
"settings.permissions.fields.friendship_list": "Friendship List",
"settings.permissions.fields.notes": "Notes",

// Field Permissions - Descriptions
"settings.permissions.descriptions.student_id": "Unique auto-generated student identifier",
"settings.permissions.descriptions.status": "Student enrollment status",
"settings.permissions.descriptions.upload_status": "Bulk upload processing status",
"settings.permissions.descriptions.upload_issues": "Issues found during bulk import",
"settings.permissions.descriptions.photo_url": "Student profile photo",
"settings.permissions.descriptions.first_name": "Student's first name",
"settings.permissions.descriptions.last_name": "Student's last name",
"settings.permissions.descriptions.birthday": "Date of birth",
"settings.permissions.descriptions.age": "Calculated age (read-only)",
"settings.permissions.descriptions.gender": "Gender (M/F/O)",
"settings.permissions.descriptions.home_county": "County of residence",
"settings.permissions.descriptions.parent_name": "Parent/guardian full name",
"settings.permissions.descriptions.parent_email": "Parent/guardian email address",
"settings.permissions.descriptions.parent_phone": "Parent/guardian phone number",
"settings.permissions.descriptions.address_1": "Address line 1",
"settings.permissions.descriptions.address_2": "Address line 2",
"settings.permissions.descriptions.address_3": "Address line 3",
"settings.permissions.descriptions.address_4": "Address line 4",
"settings.permissions.descriptions.eircode": "Irish postal code",
"settings.permissions.descriptions.course": "Enrolled course",
"settings.permissions.descriptions.house": "Assigned house",
"settings.permissions.descriptions.class_group": "Assigned class group",
"settings.permissions.descriptions.school": "Student's home school",
"settings.permissions.descriptions.school_year": "School year level",
"settings.permissions.descriptions.interview_score": "Interview assessment score",
"settings.permissions.descriptions.interview_notes": "Interview notes and observations",
"settings.permissions.descriptions.attended_before": "Previously attended flag",
"settings.permissions.descriptions.when_attended": "Previous attendance details",
"settings.permissions.descriptions.travel_required": "Travel arrangements needed",
"settings.permissions.descriptions.travel_location": "Pickup/dropoff location",
"settings.permissions.descriptions.is_cinnire": "Leadership role flag",
"settings.permissions.descriptions.oide_username": "Assigned staff member",
"settings.permissions.descriptions.student_email": "Student's own email address",
"settings.permissions.descriptions.total_paid": "Total amount paid (read-only)",
"settings.permissions.descriptions.balance_due": "Outstanding balance (read-only)",
"settings.permissions.descriptions.has_friends": "Has friendship requests",
"settings.permissions.descriptions.friend_1_id": "Friend 1 student ID (read-only)",
"settings.permissions.descriptions.friend_1_name": "Friend 1 full name (read-only)",
"settings.permissions.descriptions.friend_2_id": "Friend 2 student ID (read-only)",
"settings.permissions.descriptions.friend_2_name": "Friend 2 full name (read-only)",
"settings.permissions.descriptions.friendship_list": "List of friends in group",
"settings.permissions.descriptions.notes": "Free-text notes",

// Field Permissions - Audit Log Time
"settings.permissions.audit.justNow": "just now",
"settings.permissions.audit.minutesAgo": "{{count}} minute ago",
"settings.permissions.audit.minutesAgo_other": "{{count}} minutes ago",
"settings.permissions.audit.hoursAgo": "{{count}} hour ago",
"settings.permissions.audit.hoursAgo_other": "{{count}} hours ago",
"settings.permissions.audit.daysAgo": "{{count}} day ago",
"settings.permissions.audit.daysAgo_other": "{{count}} days ago",
"settings.permissions.audit.unknownUser": "Unknown",
"settings.permissions.editRequiresView": "Enable View permission first",
"settings.permissions.fieldReadOnly": "This field is read-only",

// Page Permissions
"settings.tabs.pagePermissions": "Page Permissions",
"settings.pagePermissions.title": "Page Permissions",
"settings.pagePermissions.description": "Configure which pages each user role can access",
"settings.pagePermissions.pageColumn": "Page",
"settings.pagePermissions.accessLabel": "Access",
"settings.pagePermissions.saveChanges": "Save Changes",
"settings.pagePermissions.saveSuccess": "Page permissions saved successfully",
"settings.pagePermissions.saveError": "Failed to save page permissions",
"settings.pagePermissions.noChanges": "No changes to save",
"settings.pagePermissions.unsavedChanges": "{{count}} unsaved change",
"settings.pagePermissions.unsavedChanges_other": "{{count}} unsaved changes",
"settings.pagePermissions.changesCancelled": "Changes cancelled",
"settings.pagePermissions.confirmTitle": "Confirm Page Permission Changes",
"settings.pagePermissions.confirmDescription": "You are about to modify {{count}} page permission(s). These changes will take effect immediately.",
"settings.pagePermissions.granted": "Granted",
"settings.pagePermissions.denied": "Denied",
"settings.pagePermissions.auditLog": "Recent Changes",
"settings.pagePermissions.noAuditLogs": "No recent changes",

// Email Templates
"settings.tabs.emailTemplates": "Email Templates",
"settings.tabs.integrations": "Integrations",
"settings.oide.title": "Oide Integration",
"settings.oide.description": "Sync student accounts to the Oide external learning platform. Students are synced automatically when their email address is first added.",
"settings.oide.stats.synced": "Synced",
"settings.oide.stats.pending": "Awaiting Sync",
"settings.oide.stats.failed": "Failed",
"settings.oide.stats.noEmail": "No Email",
"settings.oide.syncAll": "Sync All Unsynced ({{count}})",
"settings.oide.bulkQueued": "Sync Queued",
"settings.oide.bulkQueuedMessage": "{{count}} students queued for Oide sync.",
"settings.oide.bulkError": "Failed to queue Oide sync. Please try again.",
"settings.oide.failedHint": "{{count}} student(s) failed to sync — check their records for the Action Required banner.",
"settings.claru.title": "Claru Integration",
"settings.claru.description": "Insight into student deposits received from Claru — Bainisteoir creates the student and parent account automatically on arrival.",
"settings.claru.stats.total": "Students Received",
"settings.claru.stats.pendingReview": "Pending Review",
"settings.claru.stats.none": "None yet",
"settings.claru.stats.lastReceived": "Last received",
"settings.claru.stats.byCourse": "By course",
"settings.claru.stats.noneYet": "No students received via Claru yet.",
"settings.claru.stats.pendingReviewHint": "{{count}} returning-student match(es) need staff review.",
"settings.claru.stats.reviewNow": "Review Now",
"identityReview.title": "Identity Review Queue",
"identityReview.description": "Ambiguous returning-student matches from Claru, flagged for a staff decision.",
"identityReview.remaining": "{{count}} pending",
"identityReview.empty": "All caught up — nothing pending review.",
"identityReview.flaggedStudent": "Newly created student",
"identityReview.flaggedHint": "Flagged {{date}} — partially matches the record(s) below.",
"identityReview.possibleMatches": "Possible matches",
"identityReview.notAMatch": "None of these — not a match",
"identityReview.skip": "Skip for now",
"identityReview.skipDisabled": "Nothing else to skip to",
"settings.emailTemplates.title": "Email Templates",
"settings.emailTemplates.description": "Edit the email templates sent to users. Use {{variable}} placeholders as shown in each template description.",
"settings.emailTemplates.fetchError": "Failed to load email templates",
"settings.emailTemplates.saveSuccess": "Template saved",
"settings.emailTemplates.saveSuccessDesc": "{{name}} has been updated.",
"settings.emailTemplates.saveError": "Failed to save template",
"settings.emailTemplates.saving": "Saving...",
"settings.emailTemplates.save": "Save Template",
"settings.emailTemplates.subject": "Subject",
"settings.emailTemplates.body": "Email Body (HTML)",
"settings.emailTemplates.bodyPlaceholder": "Type the email message here...",
"settings.emailTemplates.noTemplates": "No email templates found.",
"settings.emailTemplates.fixedNote": "The greeting and sign-off are fixed and cannot be changed here.",
"settings.emailTemplates.templates": "Templates",
"settings.emailTemplates.requiredNote": "* Required in message body",
"settings.emailTemplates.insertVariable": "Insert variable",
"settings.emailTemplates.missingVars": "Missing required variables:",

// Page Permissions - Categories
"settings.pagePermissions.categories.Main": "Main Pages",

// Page Permissions - Page Names
"settings.pagePermissions.pages.dashboard": "Dashboard",
"settings.pagePermissions.pages.students": "Students",
"settings.pagePermissions.pages.communications": "Communications",
"settings.pagePermissions.pages.settings": "Settings",
"settings.pagePermissions.pages.houses": "Houses",
"settings.pagePermissions.pages.house-allocation": "House Allocation",
"settings.pagePermissions.pages.class-allocation": "Class Allocation",
"settings.pagePermissions.pages.classes": "Classes",
"settings.pagePermissions.pages.payments": "Payments",
"settings.pagePermissions.pages.family-dashboard": "Family Dashboard",

// Page Permissions - Descriptions
"settings.pagePermissions.descriptions.dashboard": "Main dashboard with analytics and overview",
"settings.pagePermissions.descriptions.students": "Student management and listing",
"settings.pagePermissions.descriptions.communications": "Email communications and campaigns",
"settings.pagePermissions.descriptions.settings": "System settings and configuration",
"settings.pagePermissions.descriptions.houses": "House settings and capacity management",
"settings.pagePermissions.descriptions.house-allocation": "House allocation kanban board",
"settings.pagePermissions.descriptions.classes": "Class group management",
"settings.pagePermissions.descriptions.payments": "Payment tracking and processing",
"settings.pagePermissions.descriptions.family-dashboard": "Family dashboard for parents and guardians",

// School Data Management
"settings.schoolData.title": "School Data",
"settings.schoolData.description": "Manage school reference data and configuration",
"settings.schoolData.tabs.courses": "Courses",
"settings.schoolData.tabs.travelLocations": "Travel Locations",
"settings.schoolData.tabs.schoolYears": "School Years",
"settings.schoolData.travelLocations.title": "Travel Locations",
"settings.schoolData.travelLocations.description": "Manage student travel pickup and drop-off locations",
"settings.schoolData.schoolYears.title": "School Years",
"settings.schoolData.schoolYears.description": "Manage academic years and session periods",
"settings.schoolData.comingSoon": "Coming soon...",

// System Settings
"settings.system.title": "System Settings",
"settings.system.description": "Configure general system settings and pricing",
"settings.system.travelPrice": "Travel Price",
"settings.system.travelPriceHelp": "This amount will be automatically added to the balance of students who require travel arrangements. Changes only affect students in upcoming courses.",
"settings.system.stripeDepositFee": "Stripe Deposit Fee",
"settings.system.stripeDepositFeeHelp": "This fee will be automatically subtracted from Stripe deposit amounts for display purposes. The original transaction amount is preserved in the database.",
"settings.system.invalidStripeFee": "Please enter a valid Stripe fee (0 or greater)",
"settings.system.save": "Save Changes",
"settings.system.saving": "Saving...",
"settings.system.unsavedChanges": "You have unsaved changes",
"settings.system.saveSuccess": "System settings updated successfully",
"settings.system.saveSuccessDescription": "Travel price has been updated for upcoming courses.",
"settings.system.saveError": "Failed to save system settings",
"settings.system.fetchError": "Failed to load system settings",
"settings.system.invalidPrice": "Please enter a valid price (0 or greater)",

// Course Management
"courses.management.title": "Course Management",
"courses.management.description": "Manage course offerings, capacity, and pricing",
"courses.search.placeholder": "Search courses by name, year, or description...",
"courses.showing": "Showing {{count}} course(s)",
"courses.noResults": "No courses found matching your search.",
"courses.empty": "No courses configured yet. Add your first course to get started.",
"courses.actions.addCourse": "Add Course",
"courses.fields.name": "Course Name",
"courses.fields.year": "Year",
"courses.fields.dates": "Dates",
"courses.fields.capacity": "Capacity",
"courses.fields.price": "Price",
"courses.fields.status": "Status",
"courses.fields.registered": "Registered",
"courses.status.active": "Active",
"courses.status.inactive": "Inactive",
"courses.status.completed": "Completed",
"courses.delete.title": "Delete Course",
"courses.delete.message": "Are you sure you want to delete \"{{courseName}}\"? This action cannot be undone.",
"courses.deleted": "Course Deleted",
"courses.deleteSuccess": "{{name}} has been successfully deleted.",
"courses.deleteError": "Failed to delete course. Please try again.",
"courses.created": "Course Created",
"courses.createSuccess": "{{name}} has been successfully created.",
"courses.updated": "Course Updated",
"courses.updateSuccess": "{{name}} has been successfully updated.",
"loading.courses": "Loading courses...",
"error.loadingCourses": "Error loading courses. Please try again.",

// Course Archiving (Claru integration Phase 5)
"courses.archive.nudge": "\"{{courseName}}\" finished over a week ago and is ready to archive.",
"courses.archive.archiveNow": "Archive Now",
"courses.archive.archive": "Archive",
"courses.archive.unarchive": "Unarchive",
"courses.archive.archivedBadge": "Archived",
"courses.archive.dialogTitle": "Archive Course Roster",
"courses.archive.unarchiveDialogTitle": "Unarchive Course Roster",
"courses.archive.dialogMessage": "This will archive every student in \"{{courseName}}\". Their records stay fully intact and can be restored at any time by an administrator.",
"courses.archive.unarchiveDialogMessage": "This will restore every archived student in \"{{courseName}}\" back to the active working view.",
"courses.archive.typeToConfirm": "Type the course name to confirm: {{courseName}}",
"courses.archive.passwordLabel": "Re-enter your password",
"courses.archive.confirmArchive": "Archive",
"courses.archive.confirmUnarchive": "Unarchive",
"courses.archive.success": "Course archived",
"courses.archive.unarchiveSuccess": "Course unarchived",
"courses.archive.successMessage": "{{count}} student(s) archived.",
"courses.archive.unarchiveSuccessMessage": "{{count}} student(s) restored.",
"courses.archive.genericError": "Something went wrong. Please try again.",
"courses.archive.showArchived": "Show archived",
"courses.archive.allHidden": "All courses have archived students. Toggle \"Show archived\" to see them.",

// Course Creation/Edit Modal
"courses.create.title": "Create New Course",
"courses.create.description": "Add a new course to the system",
"courses.edit.title": "Edit Course", 
"courses.edit.description": "Update course information and settings",
"courses.form.basicInfo": "Basic Information",
"courses.form.name": "Course Name",
"courses.form.namePlaceholder": "e.g., Beginners Course A",
"courses.form.abbreviation": "Abbreviation",
"courses.form.abbreviationPlaceholder": "e.g., BEG-A", 
"courses.form.abbreviationHint": "Short code for the course (uppercase letters, numbers, hyphens)",
"courses.form.description": "Description (Optional)",
"courses.form.descriptionPlaceholder": "Course description and requirements...",
"courses.form.dates": "Course Dates",
"courses.form.startDate": "Start Date",
"courses.form.endDate": "End Date", 
"courses.form.capacityAndPricing": "Capacity & Pricing",
"courses.form.capacity": "Student Capacity",
"courses.form.capacityHint": "Maximum number of students (1-200)",
"courses.form.price": "Regular Price (EUR)",
"courses.form.priceHint": "Course fee in euros",
"courses.form.cinnirePrice": "Cinnire Price (EUR)",
"courses.form.cinnirepPriceHint": "Course fee for cinnire (leaders)",
"courses.fields.cinnireLabel": "(Cinnire)",
"courses.form.numClasses": "Number of Classes",
"courses.form.numClassesHint": "Classes are named Rang A, Rang B… up to Rang Z (max 26)",
"courses.form.numClassesLocked": "Cannot change while students are assigned to classes",
"courses.form.create": "Create Course",
"courses.form.update": "Update Course",

// Travel Locations
"travelLocations.management.title": "Travel Locations",
"travelLocations.management.description": "Manage student pickup and drop-off locations",
"travelLocations.actions.addLocation": "Add Location",
"travelLocations.fields.name": "Location Name",
"travelLocations.fields.address": "Address",
"travelLocations.fields.students": "Students",
"travelLocations.fields.status": "Status",
"travelLocations.status.active": "Active",
"travelLocations.status.inactive": "Inactive",
"travelLocations.empty": "No travel locations configured yet. Add your first location to get started.",
"travelLocations.delete.title": "Delete Travel Location",
"travelLocations.delete.message": "Are you sure you want to delete \"{{locationName}}\"? This action cannot be undone.",
"travelLocations.deleted": "Location Deleted",
"travelLocations.deleteSuccess": "{{name}} has been successfully deleted.",
"travelLocations.deleteError": "Failed to delete location. Please try again.",
"travelLocations.created": "Location Created",
"travelLocations.createSuccess": "{{name}} has been successfully created.",
"travelLocations.updated": "Location Updated",
"travelLocations.updateSuccess": "{{name}} has been successfully updated.",
"travelLocations.modal.editTitle": "Edit Travel Location",
"travelLocations.modal.createTitle": "Add Travel Location",
"travelLocations.modal.editDescription": "Update the travel location details.",
"travelLocations.modal.createDescription": "Add a new pickup/drop-off location for students.",
"travelLocations.fields.locationName": "Location Name",
"travelLocations.placeholders.name": "e.g., Dublin Airport, Cork, Belfast",
"travelLocations.fields.addressOptional": "Address (Optional)",
"travelLocations.placeholders.address": "Detailed address or meeting point description...",
"travelLocations.fields.isActive": "Active Location",
"travelLocations.fields.isActiveDescription": "Whether this location is available for student selection",
"travelLocations.form.create": "Add Travel Location",
"travelLocations.form.createDescription": "Add a new pickup/drop-off location for students.",
"travelLocations.form.update": "Update Travel Location",
"loading.travelLocations": "Loading travel locations...",
"error.loadingTravelLocations": "Error loading travel locations. Please try again.",

// School Years
"schoolYears.management.title": "School Years",
"schoolYears.management.description": "Manage academic years and session periods",
"schoolYears.actions.addSchoolYear": "Add School Year",
"schoolYears.fields.year": "School Year",
"schoolYears.fields.displayOrder": "Display Order",
"schoolYears.fields.students": "Students",
"schoolYears.fields.status": "Status",
"schoolYears.status.active": "Active",
"schoolYears.status.inactive": "Inactive",
"schoolYears.empty": "No school years configured yet. Add your first school year to get started.",
"schoolYears.delete.title": "Delete School Year",
"schoolYears.delete.message": "Are you sure you want to delete \"{{schoolYearName}}\"? This action cannot be undone.",
"schoolYears.deleted": "School Year Deleted",
"schoolYears.deleteSuccess": "{{year}} has been successfully deleted.",
"schoolYears.deleteError": "Failed to delete school year. Please try again.",
"schoolYears.created": "School Year Created",
"schoolYears.createSuccess": "{{year}} has been successfully created.",
"schoolYears.updated": "School Year Updated",
"schoolYears.updateSuccess": "{{year}} has been successfully updated.",
"schoolYears.modal.editTitle": "Edit School Year",
"schoolYears.modal.createTitle": "Create School Year",
"schoolYears.modal.editDescription": "Update the school year information below.",
"schoolYears.modal.createDescription": "Create a new school year for student registration.",
"schoolYears.placeholders.year": "e.g., 1st Year, 2nd Year, Leaving Cert",
"schoolYears.placeholders.displayOrder": "0",
"schoolYears.fields.isActive": "Active",
"schoolYears.fields.isActiveDescription": "Whether this school year is currently selectable for new registrations",
"loading.schoolYears": "Loading school years...",
"error.loadingSchoolYears": "Error loading school years. Please try again.",

// Common Actions
"common.actions": "Actions",
"common.edit": "Edit",
"common.delete": "Delete",

// Permission Management
"permissions.title": "System Permissions",
"permissions.description": "Manage available system permissions",
"permissions.create": "Create Permission",
"permissions.createPermission": "Create Permission",
"permissions.createNewPermission": "Create New Permission",
"permissions.addNewPermissionDescription": "Add a new permission to the system",
"permissions.featureComingSoon": "This feature will be implemented in the next phase",
"permissions.noPermissionsFound": "No permissions found",
"permissions.tryDifferentSearchTerms": "Try different search terms",
"permissions.permissionsDisplayed": "permissions displayed",
"permissions.activeInTotal": "active in total",
"permissions.search": "Search permissions...",
"permissions.categories.all": "All Categories",
"permissions.categories.user_management": "User Management",
"permissions.categories.student_management": "Student Management",
"permissions.categories.course_management": "Course Management",
"permissions.categories.house_management": "House Management",
"permissions.categories.financial": "Financial",
"permissions.categories.reports": "Reports",
"permissions.categories.system": "System Administration",
"permissions.status.active": "Active",
"permissions.status.inactive": "Inactive",
"permissions.permissions": "permissions",
"permissions.displayed": "permissions displayed",
"permissions.totalActive": "active in total",
"permissions.noResults": "No permissions found",
"permissions.tryDifferentSearch": "Try different search terms",
"permissions.loading": "Loading permissions...",
"permissions.error": "Failed to load permissions",
"permissions.errorMessage": "There was an error loading permissions.",
"permissions.tryAgain": "Try Again",
"permissions.comingSoon": "Coming Soon",
"permissions.createFeature": "Permission creation will be implemented in the next phase.",
"permissions.toggleFeature": "Permission toggle will be implemented in the next phase.",

// Common actions (consolidated)
"common.save": "Save",
"common.confirm": "Confirm",
"common.cancel": "Cancel",
"common.next": "Next",
"common.previous": "Previous",
"common.close": "Close",
"common.moving": "Moving...",
"common.create": "Create",
"common.tryAgain": "Try Again",
"common.never": "Never",
"common.deleting": "Deleting...",
"common.unsavedChanges": "You have unsaved changes. Are you sure you want to leave?",

// Role Permissions
"rolePermissions.title": "Role Permissions",
"rolePermissions.description": "Assign permissions to different user types",
"rolePermissions.unsavedChanges": "You have unsaved changes",
"rolePermissions.save": "Save",
"rolePermissions.reset": "Reset",
"rolePermissions.loading": "Loading role permissions...",
"rolePermissions.error": "Failed to load permissions",
"rolePermissions.updated": "Permissions Updated",
"rolePermissions.updateSuccess": "Role permissions have been updated successfully.",
"rolePermissions.resetSuccess": "Permissions have been reset to previous state.",

// User Management
"users.title": "User Management", 
"users.description": "Manage system users and accounts",
"users.create": "Create User",
"users.newUser": "New User",
"users.search": "Search users...",
"users.searchPlaceholder": "Search users...",
"users.allTypes": "All Types",
"users.allStatus": "All Status",
"users.userManagement": "User Management",
"users.usersDisplayed": "users",
"users.page": "Page",
"users.of": "of",
"users.showing": "Showing",
"users.user": "User",
"users.type": "Type",
"users.status": "Status",
"users.lastLogin": "Last Login",
"users.actions": "Actions",
"users.active": "Active",
"users.inactive": "Inactive",
"users.awaitingRegistration": "Awaiting registration",
"users.verified": "Verified",
"users.unverified": "Unverified",
"users.totalUsers": "total users",
"users.admins": "Admins",
"users.viewDetails": "View Details",
"users.editUser": "Edit User",
"users.managePermissions": "Manage Permissions",
"users.deactivate": "Deactivate",
"users.activate": "Activate",
"users.userDetails": "User Details",
"users.completeUserInfo": "Complete information for the user",
"users.personalInfo": "Personal Information",
"users.systemInfo": "System Information",
"users.name": "Name",
"users.username": "Username",
"users.email": "Email",
"users.userType": "User Type",
"users.created": "User Created",
"users.loading": "Loading users...",
"users.failedToLoad": "Failed to load users",
"users.errorMessage": "There was an error loading users.",
"users.filter.all": "All Users",
"users.filter.active": "Active Users",
"users.filter.inactive": "Inactive Users",
"users.activeUsers": "active users",
"users.error": "Failed to load users",
"users.noResults": "No users found",
"users.tryDifferentSearch": "Try different search terms or filters",
"users.createSuccess": "New user has been created successfully.",
"users.updated": "User Updated", 
"users.updateSuccess": "User information has been updated successfully.",
"users.deleted": "User Deleted",
"users.deleteSuccess": "User has been removed from the system.",
"users.createFeature": "User creation will be implemented in the next phase.",
"users.updateFeature": "User editing will be implemented in the next phase.",
"users.createNewUser": "Create New User",
"users.createUserDescription": "An invitation email will be sent to the user to set their password",
"users.invitationSent": "Invitation email sent to user to set their password",
"users.firstName": "First Name",
"users.lastName": "Last Name",
"users.firstNamePlaceholder": "John",
"users.lastNamePlaceholder": "Doe",
"users.usernamePlaceholder": "johndoe",
"users.emailPlaceholder": "john.doe@example.com",
"users.userCreated": "User Created",
"users.creating": "Creating...",
"users.createUser": "Create User",
"users.resendVerification": "Resend Verification",
"users.resendVerificationSuccess": "Verification email has been resent successfully.",
"users.resendVerificationFailed": "Failed to resend verification email.",
"users.resendExpiredParents": "Resend Expired Invitation Links",
"users.resendExpiredParentsChecking": "Checking...",
"users.resendExpiredParentsSending": "Sending...",
"users.resendExpiredParentsNone": "No expired invitation links to resend right now.",
"users.resendExpiredParentsCheckFailed": "Failed to check for expired invitation links.",
"users.resendExpiredParentsConfirmTitle": "Resend expired invitation links?",
"users.resendExpiredParentsConfirmDescription": "This will send a new invitation link to {{count}} parent whose link has expired and who has a child in an upcoming course. Their old link will stop working.",
"users.resendExpiredParentsConfirmDescription_other": "This will send a new invitation link to {{count}} parents whose links have expired and who have a child in an upcoming course. Their old links will stop working.",
"users.resendExpiredParentsSuccess": "Resent the invitation link to {{count}} parent.",
"users.resendExpiredParentsSuccess_other": "Resent invitation links to {{count}} parents.",
"users.resendExpiredParentsFailed": "Failed to resend the expired invitation links.",
"users.editUserDescription": "Update user account details",
"users.saveChanges": "Save Changes",
"users.saving": "Saving...",

// User Roles with descriptions
"userRole.ADMIN": "Administrator",
"userRole.ADMIN.description": "Full system access",
"userRole.TEACHER": "Teacher", 
"userRole.TEACHER.description": "Manage students and courses",
"userRole.OFFICE": "Office Staff",
"userRole.OFFICE.description": "Administrative tasks and payments", 
"userRole.HOUSE_OWNER": "House Owner",
"userRole.HOUSE_OWNER.description": "Manage their own house",
"userRole.INTERVIEWER": "Interviewer",
"userRole.INTERVIEWER.description": "Interview new students",
"userRole.PARENT": "Parent",
"userRole.PARENT.description": "View their child's information",

// Student Management
"students.title": "Student Management",
"students.description": "Manage students and their information",
"students.search": "Search students...",
"students.searchPlaceholder": "Search by name, student ID, email...",
"students.allCourses": "All Courses",
"students.allCinnire": "All Cinnire",
"students.showingStudents": "Showing {{count}} student",
"students.showingStudents_plural": "Showing {{count}} students",
"students.fromColaiste": "from Coláiste Lurgan",
"students.noStudentsFound": "No students found.",
"students.adjustFilters": "Try adjusting your search or filters.",
"students.loadingStudents": "Loading students...",
"students.studentId": "Student ID",
"students.name": "Name",
"students.contact": "Contact",
"students.interviewScore": "Interview Score",

// Interview Scoring Panel
"interview.title": "Interview Score",
"interview.score": "Score",
"interview.notes": "Notes",
"interview.notesPlaceholder": "Add brief interview notes (max 140 characters)",
"interview.save": "Save Score",
"interview.cancel": "Cancel",
"interview.edit": "Edit Score",
"interview.addScore": "Add Score",
"interview.notScored": "Not yet scored",
"interview.scoredBy": "Scored by",
"interview.locked": "Locked",
"interview.success.saved": "Interview Score Saved",
"interview.success.savedDescription": "The interview score has been recorded successfully.",
"interview.error.scoreRequired": "Please select a score",
"interview.error.saveFailed": "Failed to Save Score",

// Student List Filters
"filters.title": "Filter Students",
"filters.description": "Refine your list with multiple criteria",
"filters.button": "Filters",
"filters.apply": "Apply Filters",
"filters.clearAll": "Clear all",
"filters.filterActive": "filter active",
"filters.filtersActive": "filters active",
"filters.noFilter": "All",

// Filter Sections
"filters.section.student": "Student",
"filters.section.academic": "Academic",
"filters.section.financial": "Financial",
"filters.section.dataQuality": "Data Quality",
"filters.section.campaign": "Campaign",

// Filter Labels
"filters.status": "Status",
"filters.role": "Role",
"filters.course": "Course",
"filters.friends": "Friends",
"filters.allStatuses": "All",
"filters.allStudents": "All",
"filters.allCourses": "All",
"filters.cinniriOnly": "Cinniri Only",
"filters.nonCinniri": "Non-Cinniri",
"filters.hasFriends": "Has Friends",
"filters.noFriends": "No Friends",
"filters.noCourses": "No courses available",

// Interview Filters
"filters.interview.title": "Interview Stage",
"filters.interview.label": "Interview",
"filters.interview.description": "Filter by interview scoring status",
"filters.interview.all": "All",
"filters.interview.scored": "Scored",
"filters.interview.notScored": "Not Scored",
"filters.interview.byScore": "By Score",
"filters.interview.score": "Score",

// Payment Filters
"filters.payment.title": "Payment Stage",
"filters.payment.label": "Payment",
"filters.payment.description": "Filter by payment status",
"filters.payment.all": "All",
"filters.payment.fullyPaid": "Fully Paid",
"filters.payment.outstanding": "Outstanding",
"filters.payment.noPayments": "No Payments",
"filters.payment.refunded": "Refunded",
"filters.payment.depositOnly": "Deposit Only",

// Import Filters
"filters.import": "Import",
"filters.import.withIssues": "With Issues",
"filters.import.warnings": "Warnings",
"filters.import.errors": "Errors",
"filters.import.actionRequired": "Action Required",

// Campaign Filters
"filters.emailStatus": "Email",
"filters.campaign.sent": "Already Sent",
"filters.campaign.notSent": "Not Sent",

"students.course": "Course",
"students.house": "House",
"students.indicators": "Indicators",
"students.status": "Status",
"students.actions": "Actions",
"students.cinnire": "Cinnire (Leader)",
"students.travelRequired": "Travel Required",
"students.hasFriends": "Has Friends",
"students.selectAll": "Select All",
"students.selected": "selected",
"students.bulkActions": "Bulk Actions",
"students.archive": "Archive Selected",
"students.export": "Export Selected",
"students.newStudent": "New Student",
"students.bulkUpload": "Bulk Upload",
"students.uploadStatus.all": "All Upload Types",
"students.uploadStatus.manual": "Manual Registration",
"students.uploadStatus.imported": "Bulk Import - Valid",
"students.uploadStatus.withIssues": "With Issues (Both)",
"students.uploadStatus.withWarnings": "Warnings Only",
"students.uploadStatus.withErrors": "Errors Only",
"students.uploadStatus.actionRequired": "Action Required",
"students.actionRequired": "Action Required",
"students.importWarning": "Import Warning",
"students.importError": "Import Error",
"students.flag.button": "Add Action Note",
"students.flag.title": "Add Action Note",
"students.flag.description": "Add a note explaining what action is required. This will mark the student as Action Required and appear in their record.",
"students.flag.notePlaceholder": "Describe what action is needed…",
"students.flag.confirm": "Add Action Note",
"students.flag.success": "Student Flagged",
"students.flag.successMessage": "The student has been flagged for action.",
"students.flag.error": "Failed to flag student. Please try again.",
"students.issues": "issues",
"students.uploadIssues.hasErrors": "Upload Errors Found",
"students.uploadIssues.hasWarnings": "Upload Warnings Found",
"students.uploadIssues.hasActions": "Action Required",
"students.uploadIssues.resolveIssue": "Dismiss",
"students.uploadIssues.markResolved": "Mark Resolved",
"students.uploadIssues.confirmResolveTitle": "Mark Issues as Resolved",
"students.uploadIssues.confirmResolve": "Are you sure you want to mark these upload issues as resolved? This will update the student record to show no import warnings.",
"students.uploadIssues.resolved": "Issues Resolved",
"students.uploadIssues.resolvedMessage": "Upload issues have been marked as resolved",
"students.uploadIssues.resolveFailed": "Failed to resolve issues. Please try again.",
"students.viewProfile": "View Profile",
"students.editStudent": "Edit Student",
"students.paymentHistory": "Payment History",
"students.payment.outstandingBalance": "Outstanding Balance",
"students.payment.balanceDue": "€{{amount}} remaining to be paid",
"students.payment.paidSoFar": "Paid: €{{amount}}",
"students.payment.fullyPaid": "Fully Paid",
"students.payment.paidAmount": "Total paid: €{{amount}}",
"students.archiveStudent": "Archive Student",
"students.age": "Age {{age}}",
"students.notAssigned": "Not assigned",
"students.noContactInfo": "No contact info",
"students.studentActions": "Student Actions",
"students.ofTotal": "{{filtered}} of {{total}} students",
"students.filtered": "filtered",
"students.total": "total",
"students.clickToSort": "Click to sort",
"students.sortedAscending": "Sorted ascending",
"students.sortedDescending": "Sorted descending",
"students.cancel.title": "Cancel Student Enrollment",
"students.cancel.message": "Are you sure you want to cancel {{studentName}}'s enrollment? This action can be reversed later by changing their status.",
"students.cancelled": "Student Cancelled",
"students.cancelSuccess": "{{studentName}} has been cancelled successfully",
"students.cancelError": "Failed to cancel student. Please try again.",
"students.cancelling": "Cancelling...",
"students.cancelEnrollment": "Cancel Enrollment",
"students.updated": "Student Updated",
"students.updateSuccess": "{{studentName}} has been updated successfully",
"students.created": "Student Registered",
"students.createSuccess": "{{studentName}} has been added to the system",
"students.error.updateFailed": "Failed to update student",
"students.error.createFailed": "Failed to create student",
"students.error.loadStudentsFailed": "Failed to load students",
"students.results": "results",
"students.stats.total": "Total Students",
"students.stats.active": "Active",
"students.stats.male": "Male",
"students.stats.female": "Female",
"students.reinstate.title": "Reinstate Student",
"students.reinstate.message": "Are you sure you want to reinstate {{studentName}}? Their status will be changed back to ACTIVE.",
"students.reinstated": "Student Reinstated",
"students.reinstateSuccess": "{{studentName}} has been reinstated successfully",
"students.reinstateError": "Failed to reinstate student. Please try again.",
"students.reinstateButton": "Reinstate Student",
"students.backToStudents": "Back to Students",

// Student Edit Mode
"students.edit.saveChanges": "Save Changes",
"students.edit.cancelChanges": "Cancel Changes",
"students.edit.editModeActive": "Edit Mode Active",
"students.edit.unsavedChanges": "Unsaved changes",
"students.edit.noChanges": "No changes",
"students.edit.saving": "Saving...",
"students.edit.validationErrors": "Please fix {{count}} validation error",
"students.edit.validationErrors_plural": "Please fix {{count}} validation errors",
"students.edit.editProfile": "Edit Profile",
"students.edit.edit": "Edit",
"students.edit.editProfileDesc": "Update student details below",

// Student Form Labels
"students.form.firstName": "First Name",
"students.form.lastName": "Last Name",
"students.form.studentId": "Student ID",
"students.form.classGroup": "Class Group",
"students.form.schoolYear": "School Year",
"students.form.interviewScore": "Interview Score",
"students.form.previousAttendance": "Previous Attendance",
"students.form.previouslyAttended": "Previously Attended",
"students.form.studentEmail": "Student Email",
"students.form.travelRequired": "Travel Required",
"students.form.travelLocation": "Travel Location",
"students.form.hasFriends": "Has Friends",
"students.form.leadershipRole": "Leadership Role",
"students.form.assignedStaff": "Assigned Staff",
"students.form.addressLine1": "Address Line 1",
"students.form.addressLine2": "Address Line 2",
"students.form.addressLine3": "Address Line 3",
"students.form.addressLine4": "Address Line 4",
"students.form.eircode": "Eircode",
"students.form.homeCounty": "Home County",
"students.form.dateOfBirth": "Date of Birth",
"students.form.age": "Age",
"students.form.gender": "Gender",
"students.form.course": "Course",
"students.form.house": "House",
"students.form.school": "School",

// Student Detail - Validation Messages
"students.validation.firstNameMinLength": "First name must be at least 2 characters",
"students.validation.firstNameMaxLength": "First name cannot exceed 50 characters",
"students.validation.firstNameInvalid": "Please enter a valid name (letters, spaces, hyphens, and apostrophes only)",
"students.validation.lastNameMinLength": "Last name must be at least 2 characters",
"students.validation.lastNameMaxLength": "Last name cannot exceed 50 characters",
"students.validation.lastNameInvalid": "Please enter a valid name (letters, spaces, hyphens, and apostrophes only)",
"students.validation.birthdayRequired": "Date of birth is required",
"students.validation.birthdayFuture": "Date of birth cannot be in the future",
"students.validation.parentNameRequired": "Parent/Guardian name is required",
"students.validation.parentNameMaxLength": "Parent/Guardian name cannot exceed 100 characters",
"students.validation.parentNameInvalid": "Name can only contain letters, spaces, hyphens, and apostrophes",
"students.validation.parentEmailRequired": "Parent/Guardian email is required",
"students.validation.parentEmailInvalid": "Invalid email address",
"students.validation.parentPhoneRequired": "Parent/Guardian phone is required",
"students.validation.parentPhoneInvalid": "Please enter a valid phone number",
"students.validation.homeCountyRequired": "Home county is required",
"students.validation.address1Required": "Address line 1 is required",
"students.validation.genderRequired": "Gender is required",
"students.validation.courseRequired": "Course is required",
"students.validation.schoolYearRequired": "School year is required",
"students.validation.travelLocationRequired": "Travel location is required when travel is needed",

// Student Detail - Status Labels
"students.status.active": "Active",
"students.status.completed": "Completed",
"students.status.archived": "Archived",
"students.status.cancelled": "Cancelled",
"students.status.unknown": "Unknown",

// Student Detail - Badge Labels
"students.badge.cinnire": "Cinnire",
"students.badge.travelRequired": "Travel Required",
"students.badge.hasFriends": "Has Friends",
"students.badge.travel": "Travel",
"students.badge.friends": "Friends",
"students.badge.placed": "Placed",
"students.badge.yes": "Yes",
"students.badge.no": "No",
"students.badge.none": "None",
"students.badge.previouslyAttended": "Previously Attended",

// Student Detail - Placeholders
"students.placeholders.firstName": "First name",
"students.placeholders.lastName": "Last name",
"students.placeholders.selectGender": "Select gender",
"students.placeholders.county": "County",
"students.placeholders.studentEmail": "Student email address",
"students.placeholders.addressLine1": "Address line 1",
"students.placeholders.addressLine2": "Address line 2",
"students.placeholders.addressLine3": "Address line 3",
"students.placeholders.addressLine4": "Address line 4",
"students.placeholders.eircode": "Eircode",
"students.placeholders.selectCourse": "Select course",
"students.placeholders.selectSchoolYear": "Select school year",
"students.placeholders.selectTravelLocation": "Select travel location",
"students.placeholders.schoolName": "School name",
"students.placeholders.addNotes": "Add notes about the student...",
"students.placeholders.parentName": "Parent/Guardian name",
"students.placeholders.parentEmail": "parent@example.com",
"students.placeholders.phoneNumber": "Phone number",

// Student Detail - Loading & Error States
"students.loading.details": "Loading student details...",
"students.error.loadFailed": "Failed to load student",
"students.error.loadMessage": "There was an error loading the student data.",
"students.error.tryAgain": "Try Again",
"students.error.notFound": "Student not found",
"students.error.notFoundMessage": "The student you're looking for doesn't exist or has been removed.",
"students.error.accessDenied": "Access Denied",
"students.error.cannotEdit": "{{userType}} role cannot edit student information.",

// Student Detail - Common Labels & Text
"students.labels.studentId": "Student ID:",
"students.labels.parentGuardian": "Parent/Guardian",
"students.labels.email": "Email",
"students.labels.phone": "Phone",
"students.labels.status": "Status",
"students.labels.age": "Age",
"students.labels.yearsOld": "years old",
"students.labels.male": "Male",
"students.labels.female": "Female",
"students.labels.other": "Other",
"students.labels.notSpecified": "Not specified",
"students.labels.notProvided": "Not provided",
"students.labels.noDetails": "No details provided",
"students.labels.noNotes": "No notes available",
"students.labels.contactInformation": "Contact Information",
"students.labels.quickStats": "Quick Stats",
"students.labels.edit": "Edit",
"students.labels.cancelEnrollment": "Cancel Enrollment",
"students.labels.reinstateStudent": "Reinstate Student",

// Student Detail - Breadcrumb & Navigation
"students.breadcrumb.students": "Students",

// Student Detail - Unsaved Changes
"students.unsavedChanges.confirm": "You have unsaved changes. Are you sure you want to leave?",
"students.unsavedChanges.discard": "You have unsaved changes. Are you sure you want to discard them?",

// Student Detail - Upload Issues
"students.uploadIssues.issuesCount_one": "{{count}} issue found during bulk import.",
"students.uploadIssues.issuesCount_other": "{{count}} issues found during bulk import.",
"students.uploadIssues.mayAffectAccuracy": " These errors may affect data accuracy.",
"students.uploadIssues.pleaseReview": " Please review and resolve these warnings.",
"students.uploadIssues.hide": "Hide",
"students.uploadIssues.show": "Show",
"students.uploadIssues.allIssues": "All Issues ({{count}})",

// Student Registration Form
"studentReg.title": "Student Registration",
"studentReg.step": "Step {{current}} of {{total}}",
"studentReg.personalInfo": "Personal Information",
"studentReg.personalInfoDescription": "Enter the student's basic personal details",
"studentReg.addressInfo": "Address Information", 
"studentReg.addressInfoDescription": "Student's home address and location details",
"studentReg.parentContact": "Parent/Guardian Contact",
"studentReg.parentContactDescription": "Primary contact information for parents/guardians",
"studentReg.academicInfo": "Academic Information",
"studentReg.academicInfoDescription": "Course and class preferences",
"studentReg.travelInfo": "Travel Information", 
"studentReg.travelInfoDescription": "Transportation and travel arrangements",
"studentReg.reviewSubmit": "Review & Submit",
"studentReg.reviewSubmitDescription": "Review all information before submitting",
"studentReg.previous": "Previous",
"studentReg.next": "Next",
"studentReg.submit": "Submit Registration",
"studentReg.firstName": "First Name",
"studentReg.lastName": "Last Name",
"studentReg.irishName": "Irish Name",
"studentReg.irishNameOptional": "Irish Name (Optional)",
"studentReg.dateOfBirth": "Date of Birth",
"studentReg.gender": "Gender",
"studentReg.male": "Male",
"studentReg.female": "Female", 
"studentReg.other": "Other",
"studentReg.email": "Email",
"studentReg.mobile": "Mobile Phone",
"studentReg.homePhone": "Home Phone",
"studentReg.address": "Address Line 1",
"studentReg.address2": "Address Line 2",
"studentReg.city": "City",
"studentReg.county": "County",
"studentReg.country": "Country",
"studentReg.parentName": "Parent/Guardian Name",
"studentReg.parentEmail": "Parent/Guardian Email",
"studentReg.parentPhone": "Parent/Guardian Phone",
"studentReg.emergencyContact": "Emergency Contact",
"studentReg.emergencyPhone": "Emergency Phone",
"studentReg.coursePreferences": "Course Preferences",
"studentReg.housePreferences": "House Preferences",
"studentReg.specialRequirements": "Special Requirements",
"studentReg.medicalInfo": "Medical Information",
"studentReg.dietaryRequirements": "Dietary Requirements",
"studentReg.travelLocation": "Travel Location",
"studentReg.needsTransport": "Needs Transport",
"studentReg.registrationComplete": "Registration Complete!",
"studentReg.processing": "Processing registration...",
"studentReg.success": "Student registered successfully",
"studentReg.error": "Registration failed. Please try again.",

// Additional form fields
"studentReg.school": "School",
"studentReg.schoolYear": "School Year",
"studentReg.course": "Course",
"studentReg.address3": "Address Line 3",
"studentReg.address4": "Address Line 4",
"studentReg.eircode": "Eircode",
"studentReg.attendedBefore": "Attended Before",
"studentReg.whenAttended": "When Attended",
"studentReg.travelRequired": "Travel Required",

// Placeholders
"studentReg.placeholders.firstName": "Enter first name",
"studentReg.placeholders.lastName": "Enter last name",
"studentReg.placeholders.address1": "Enter address line 1",
"studentReg.placeholders.address2": "Enter address line 2 (optional)",
"studentReg.placeholders.address3": "Enter address line 3 (optional)",
"studentReg.placeholders.address4": "Enter address line 4 (optional)",
"studentReg.placeholders.county": "Enter county",
"studentReg.placeholders.eircode": "Enter eircode (optional)",
"studentReg.placeholders.parentName": "Enter parent or guardian name",
"studentReg.placeholders.parentEmail": "Enter parent or guardian email",
"studentReg.placeholders.parentPhone": "Enter phone number",
"studentReg.placeholders.school": "Enter school name (optional)",
"studentReg.placeholders.whenAttended": "Enter when the student previously attended",
"studentReg.placeholders.selectSchoolYear": "Select school year",
"studentReg.placeholders.selectCourse": "Select course",
"studentReg.placeholders.selectTravelLocation": "Select pickup location",
"studentReg.placeholders.loadingSchoolYears": "Loading school years...",
"studentReg.placeholders.loadingCourses": "Loading courses...",
"studentReg.placeholders.loadingLocations": "Loading locations...",

// Student Detail
"studentDetail.profile": "Student Profile",
"studentDetail.overview": "Overview",
"studentDetail.contact": "Contact",
"studentDetail.academic": "Academic",
"studentDetail.medical": "Medical",
"studentDetail.travel": "Travel",
"studentDetail.payments": "Payments",
"studentDetail.communications": "Communications",
"studentDetail.basicInfo": "Basic Information",
"studentDetail.contactInfo": "Contact Information",
"studentDetail.academicDetails": "Academic Details",
"studentDetail.medicalInfo": "Medical Information",
"studentDetail.travelDetails": "Travel Details",
"studentDetail.paymentHistory": "Payment History", 
"studentDetail.emailHistory": "Email History",
"studentDetail.noPayments": "No payments recorded",
"studentDetail.noEmails": "No emails sent",

// Student Statuses
"status.ACTIVE": "Active",
"status.COMPLETED": "Completed", 
"status.ARCHIVED": "Archived",
"status.CANCELLED": "Cancelled",

// Gender Options
"gender.M": "Male",
"gender.F": "Female",
"gender.O": "Other",
"gender.NA": "N/A",

// Communications
"communications.title": "Communications",
"communications.description": "Manage email campaigns and analyze performance",
"communications.newEmail": "New Email",
"communications.analytics": "Analytics",
"communications.emails": "Emails",
"communications.totalEmails": "Total emails",
"communications.emailTemplates": "Email Templates",
"communications.sendHistory": "Send History",
"communications.recipients": "Recipients",
"communications.emailsSent": "Emails sent",
"communications.deliveryRate": "Delivery Rate",
"communications.emailsDelivered": "Emails delivered",
"communications.openRate": "Open Rate",
"communications.emailsOpened": "Emails opened",
"communications.emailCampaigns": "Email Campaigns",
"communications.manageCampaigns": "Manage and monitor your email campaigns",
"communications.searchCampaigns": "Search campaigns...",
"communications.allStatus": "All Status",
"communications.sent": "Sent",
"communications.delivered": "Delivered",
"communications.failed": "Failed",
"communications.noCampaigns": "No campaigns",
"communications.noCampaignsFound": "No campaigns match your search criteria",
"communications.noCampaignsExist": "No email campaigns exist yet",
"communications.createCampaign": "Create Campaign",
"communications.noPermission": "You don't have permission to view communications.",
"communications.type": "Type",
"communications.subject": "Subject",
"communications.status": "Status",
"communications.sentAt": "Sent At",
"communications.sentBy": "Sent By",
"communications.performance": "Performance",
"communications.actions": "Actions",
"communications.date": "Date",
"communications.opened": "opened",
"communications.noEmailsFound": "No emails found",
"communications.noEmailsMatchSearch": "No emails match your search criteria",
"communications.noEmailsExist": "No emails exist yet",
"communications.createEmail": "Create Email",
"communications.total": "total",
"communications.filtered": "filtered",
"communications.searchPlaceholder": "Search communications...",
"communications.allStatuses": "All Statuses",
"communications.allEmails": "All Emails",
"communications.sentOnly": "Sent Only",
"communications.draftsOnly": "Drafts Only",
"communications.created": "Created",
"communications.noEmails": "No emails found",
"communications.createFirstEmail": "Create your first email to get started",
"communications.confirmDeleteTitle": "Delete Draft",
"communications.confirmDeleteDescription": "Are you sure you want to delete this draft? This action cannot be undone.",
"communications.noContentPreview": "No content preview available for this email.",
"communications.contentTruncated": "Content has been truncated to 500 characters.",
"communications.previewDraft": "Preview Draft",
"communications.previewEmail": "Preview Email",
"communications.emailPreview": "Email Preview",
"communications.sendAgain": "Send Again",
"communications.retryQueued": "Retry Queued",
"communications.retryQueuedDescription": "Retrying failed recipients in the background",
"communications.retrySuccess": "Retry Successful",
"communications.retrySuccessDescription": "Successfully retried failed recipients",
"communications.retryPartialSuccess": "Retry Partially Successful",
"communications.retryFailed": "Retry Failed",
"communications.retryFailedDescription": "Failed to retry sending",
"communications.acknowledgeFailed": "Mark as Reviewed",
"communications.acknowledgeSuccess": "Emails Acknowledged",
"communications.acknowledgeSuccessDescription": "Failed emails marked as reviewed",
"communications.acknowledgeFailedDescription": "Failed to acknowledge emails",
"communications.noEmailsToAcknowledge": "No Emails to Acknowledge",
"communications.noEmailsToAcknowledgeDescription": "No failed emails found to acknowledge",
"communications.resend_edit_notice": "Editing a previous email — make any changes below, then proceed to select recipients.",

// Recipient Selector
"recipients.filters": "Filters",
"recipients.clear": "Clear",
"recipients.clearAll": "Clear All",
"recipients.course": "Course",
"recipients.house": "House",
"recipients.class": "Class",
"recipients.schoolYear": "School Year",
"recipients.payment": "Payment",
"recipients.travel": "Travel",
"recipients.email": "Email",
"recipients.emailToParents": "Emails will be sent to parent addresses",
"recipients.emailToStudents": "Emails will be sent to student addresses",

// Email Creation
"email.title": "New Email",
"email.createNew": "Create New Email",
"email.description": "Create a new email",
"email.back": "Back",
"email.editor": "Editor",
"email.preview": "Preview",
"email.test": "Test",
"email.save": "Save",
"email.saveAsDraft": "Save as Draft",
"email.send": "Send",
"email.details": "Email Details",
"email.detailsDescription": "Set up the basic information for your email",
"email.emailType": "Email Type",
"email.emailName": "Email Name",
"email.subject": "Subject",
"email.sendToParents": "Send to parent email addresses",
"email.emailContent": "Email Content",
"email.writeContent": "Write your email content. Use the sidebar on the right to insert dynamic fields.",
"email.recipients": "Recipients",
"email.selectRecipients": "Select Recipients",
"email.recipientsDescription": "Choose who will receive this email",
"email.emailPreview": "Email Preview",
"email.previewDescription": "This is how recipients will see your email",
"email.previewNote": "Preview Note:",
"email.sendTestEmail": "Send Test Email",
"email.testDescription": "Enter email address to send test",
"email.emailAddress": "Email Address",
"email.cancel": "Cancel",
"email.sending": "Sending...",
"email.selected": "selected",
"email.dynamicFieldsNote": "Dynamic fields (like {{student.first_name}}) will be replaced with actual data when the email is sent.",
"email.draftSaved": "Draft Saved",
"email.draftSavedDescription": "Your email has been saved as a draft successfully.",
"email.draftUpdated": "Draft Updated",
"email.draftUpdatedDescription": "Your email draft has been updated successfully.",
"email.draftSaveFailed": "Failed to Save Draft",
"email.draftSaveFailedDescription": "There was an error saving your draft. Please try again.",
"email.draftDeleted": "Draft Deleted",
"email.draftDeletedDescription": "Your email draft has been deleted successfully.",
"email.draftDeleteFailed": "Failed to Delete Draft",
"email.draftDeleteFailedDescription": "There was an error deleting your draft. Please try again.",
"email.draftLoaded": "Draft Loaded",
"email.draftLoadedDescription": "Your email draft has been loaded for editing.",
"email.draftLoadFailed": "Failed to Load Draft",
"email.draftLoadFailedDescription": "There was an error loading your draft. Please try again.",
"email.campaignSent": "Email Campaign Sent",
"email.campaignSentDescription": "Your email has been sent successfully to {{count}} recipient(s).",
"email.campaignSendFailed": "Failed to Send Email",
"email.campaignSendFailedDescription": "There was an error sending your email. Please try again.",
"email.testSent": "Test Email Sent",
"email.testSentDescription": "A test email has been sent to {{email}}.",
"email.testSendFailed": "Failed to Send Test Email",
"email.testSendFailedDescription": "There was an error sending the test email. Please try again.",

// Email Attachments
"email.attachments": "Attachments",
"email.addAttachment": "Add Attachment",
"email.uploadingFile": "Uploading file...",
"email.fileUploaded": "File uploaded successfully",
"email.uploadFailed": "Upload failed",
"email.fileTooLarge": "File too large",
"email.maxFileSize": "Maximum file size is {{size}}",
"email.invalidFileType": "Invalid file type",
"email.onlyPdfAllowed": "Only PDF files are allowed",
"email.totalSizeTooLarge": "Total attachments size exceeds limit",
"email.maxTotalSize": "Maximum total size is {{size}}",
"email.deleteAttachment": "Delete attachment",
"email.attachmentDeleted": "Attachment deleted successfully",
"email.deleteFailed": "Failed to delete attachment",
"email.downloadFailed": "Failed to download file",
"email.noAttachments": "No attachments",
"email.attachmentCount": "{{count}} attachment(s)",
"email.saveDraftFirst": "Please save your draft before adding attachments",
"email.savingDraft": "Saving draft...",
"email.saveDraftToAddAttachments": "Save Draft",
"email.autoSaving": "Auto-saving...",
"email.nowAddAttachments": "Draft saved! Now you can add attachments.",
"email.clickAgainToUpload": "Click 'Add Attachment' again to select your file",
"email.saveFailed": "Failed to save draft",
"email.pleaseSaveManually": "Please save manually and try again",
"email.draftWillBeSavedAutomatically": "Draft will be saved automatically when you add an attachment",
"email.pdfOnlyInfo": "PDF files only.",
"email.maxFileSizeInfo": "Maximum {{size}} per file.",

// Wizard Navigation
"wizard.page": "Page",
"wizard.of": "of",
"wizard.step1of2": "Step 1 of 2: Create Content",
"wizard.step2of2": "Step 2 of 2: Select Recipients",
"wizard.backToContent": "Back to Content",
"wizard.nextSelectRecipients": "Next: Select Recipients",
"campaign.emailTypeRequired": "Email type is required",
"campaign.campaignName": "Campaign Name",
"campaign.subject": "Subject",
"campaign.subjectRequired": "Subject is required",
"campaign.sendToParents": "Send to parent email addresses",
"campaign.emailContent": "Email Content",
"campaign.contentDescription": "Write your email content. Use the sidebar on the right to insert dynamic fields.",
"campaign.recipients": "Recipients",
"campaign.selected": "selected",
"campaign.recipientsRequired": "At least one recipient must be selected",
"campaign.emailPreview": "Email Preview",
"campaign.previewDescription": "This is how recipients will see your email",
"campaign.previewNote": "Preview Note:",
"campaign.previewNoteDynamic": "Dynamic fields (like {{student.first_name}}) will be replaced with actual data when the email is sent.",
"campaign.sending": "Sending...",
"campaign.testEmail": "Send Test Email",
"campaign.testEmailDescription": "Enter email address to send test",
"campaign.emailAddress": "Email Address",
"campaign.cancel": "Cancel",

// Dynamic Fields
"dynamicFields.title": "Dynamic Fields",
"dynamicFields.description": "Click to insert fields into email",
"dynamicFields.search": "Search fields...",
"dynamicFields.commonlyUsed": "Commonly Used",
"dynamicFields.insert": "Insert",
"dynamicFields.howToUse": "How to use:",
"dynamicFields.clickField": "Click a field to insert it",
"dynamicFields.realData": "Real data will replace fields when sent",
"dynamicFields.clickToInsert": "Click a field to insert it",
"dynamicFields.realDataReplaced": "Real data will replace fields when sent",
"dynamicFields.hoverToSeeCode": "Hover over fields to see their codes",
"dynamicFields.quickInsert": "Quick Insert",
"dynamicFields.inserted": "inserted",
"dynamicFields.noFields": "No fields found",
"dynamicFields.buildConditional": "Build Conditional Content",
"dynamicFields.conditionalDescription": "Create smart messages with if/then logic",

// Condition Builder
"conditionBuilder.title": "Conditional Content Builder",
"conditionBuilder.description": "Create smart messages that show different content based on conditions. Perfect for personalized emails.",
"conditionBuilder.required": "(Required)",
"conditionBuilder.selectCondition": "Select Condition",
"conditionBuilder.chooseCondition": "Choose a condition...",
"conditionBuilder.customCode": "Custom Condition Code",
"conditionBuilder.customHelp": "Enter Django template condition syntax",
"conditionBuilder.thenShow": "Then Show This Message",
"conditionBuilder.messageExample": "Enter the message to show when this condition is true...",
"conditionBuilder.addElseIf": "Add Else If",
"conditionBuilder.addElse": "Add Else (Optional Fallback)",
"conditionBuilder.otherwiseShow": "(Otherwise show)",
"conditionBuilder.defaultMessage": "Default Message",
"conditionBuilder.elseExample": "Enter the message to show if none of the above conditions are true...",
"conditionBuilder.showPreview": "Show Code Preview",
"conditionBuilder.hidePreview": "Hide Preview",
"conditionBuilder.insertConditional": "Insert Conditional Content",
"conditionBuilder.insertField": "Insert Field",
"conditionBuilder.friendsTemplates": "Friends (Templates)",
"conditionBuilder.friendsList": "List All Friends",
"conditionBuilder.friendsListDesc": "Comma-separated list of friend names",
"conditionBuilder.friendsListBullets": "Bullet List of Friends",
"conditionBuilder.friendsListBulletsDesc": "Bulleted list with one friend per line",
"conditionBuilder.friendsCount": "Number of Friends",
"conditionBuilder.friendsCountDesc": "Shows how many friends they have",
"conditionBuilder.selectValue": "Select Value",
"conditionBuilder.chooseValue": "Choose a value...",
"conditionBuilder.schoolYearEquals": "School Year equals",
"conditionBuilder.genderEquals": "Gender equals",
"conditionBuilder.statusEquals": "Status equals",
"conditionBuilder.interviewStatusEquals": "Interview Status equals",
"conditionBuilder.travelLocationEquals": "Travel Location equals",
"conditionBuilder.courseNameEquals": "Course equals",
"conditionBuilder.houseEquals": "House equals",
"conditionBuilder.quickInsert": "Quick Insert:",

// Quick Insert Fields
"quickField.friendsList": "List all friends",
"quickField.friendsBullets": "Friends (bullets)",
"quickField.friendCount": "Number of friends",
"quickField.balanceDue": "Balance due",
"quickField.totalPaid": "Total paid",
"quickField.depositPaid": "Deposit paid",
"quickField.coursePrice": "Course price",
"quickField.travelLocation": "Travel location",
"quickField.travelAddress": "Location address",
"quickField.travelNotes": "Travel notes",
"quickField.studentName": "Student name",
"quickField.parentName": "Parent name",
"quickField.courseName": "Course name",
"quickField.courseStart": "Course start date",
"quickField.courseEnd": "Course end date",
"quickField.schoolYear": "School year",
"quickField.whenAttended": "When attended",

// School Years
"schoolYear.1st": "1st Year",
"schoolYear.2nd": "2nd Year",
"schoolYear.3rd": "3rd Year",
"schoolYear.4th": "4th Year",
"schoolYear.5th": "5th Year",
"schoolYear.6th": "6th Year",

// Gender
"gender.male": "Male",
"gender.female": "Female",

// Status
"status.active": "Active",
"status.withdrawn": "Withdrawn",
"status.pending": "Pending",

// Interview Status
"interviewStatus.notInterviewed": "Not Interviewed",
"interviewStatus.interviewed": "Interviewed",
"interviewStatus.passed": "Passed",
"interviewStatus.failed": "Failed",

// Condition Categories
"conditionCategory.payment": "Payment & Financial",
"conditionCategory.studentStatus": "Student Status",
"conditionCategory.friends": "Friends & Social",
"conditionCategory.travel": "Travel & Logistics",
"conditionCategory.course": "Course Information",
"conditionCategory.specificValue": "Specific Value Checks",
"conditionCategory.custom": "Custom Condition",

// Condition Options
"condition.balanceDue": "Balance Due (owes money)",
"condition.fullyPaid": "Fully Paid (no balance)",
"condition.depositPaid": "Deposit Paid",
"condition.depositNotPaid": "Deposit Not Paid",
"condition.hasPayments": "Has Made Payments",
"condition.noPayments": "No Payments Yet",
"condition.isCinnire": "Is a Cinnire (Leader)",
"condition.notCinnire": "Not a Cinnire",
"condition.attendedBefore": "Attended Before (Returning)",
"condition.firstTime": "First Time Attending",
"condition.statusActive": "Status is Active",
"condition.statusWithdrawn": "Status is Withdrawn",
"condition.hasFriends": "Has Friends Attending",
"condition.noFriends": "No Friends Attending",
"condition.travelRequired": "Travel Required",
"condition.noTravel": "No Travel Required",
"condition.hasTravelLocation": "Has Travel Location Set",
"condition.hasEnrolledCourse": "Enrolled in a Course",
"condition.hasSchoolYear": "School Year Set",
"condition.custom": "Custom Condition (Advanced)",

// Field Categories
"fieldCategory.student": "Student Information",
"fieldCategory.parent": "Parent Information",
"fieldCategory.address": "Address Information",
"fieldCategory.course": "Course & Housing",
"fieldCategory.travel": "Travel Information",
"fieldCategory.financial": "Financial Information",
"fieldCategory.system": "System Information",

// Field Labels - Student
"field.student.firstName": "First Name",
"field.student.lastName": "Last Name",
"field.student.fullName": "Full Name",
"field.student.studentId": "Student ID",
"field.student.email": "Email Address",
"field.student.phone": "Phone Number",
"field.student.dateOfBirth": "Date of Birth",
"field.student.age": "Age",
"field.student.genderCode": "Gender (M/F)",
"field.student.genderEnglish": "Gender (Boy/Girl)",
"field.student.genderIrish": "Inscne (Buachaill/Cailín)",
"field.student.schoolYear": "School Year",
"field.student.currentSchool": "Current School",
"field.student.homeCounty": "Home County",

// Field Labels - Parent
"field.parent.name": "Parent Name",
"field.parent.email": "Parent Email",
"field.parent.phone": "Parent Phone",
"field.parent.emergencyContact": "Emergency Contact",
"field.parent.emergencyPhone": "Emergency Phone",

// Field Labels - Address
"field.address.line1": "Address Line 1",
"field.address.line2": "Address Line 2",
"field.address.line3": "Address Line 3",
"field.address.line4": "Address Line 4",
"field.address.eircode": "Eircode",
"field.address.city": "City",
"field.address.county": "County",
"field.address.postalCode": "Postal Code",
"field.address.country": "Country",
"field.address.full": "Full Address",

// Field Labels - Course
"field.course.name": "Course Name",
"field.course.startDate": "Course Start Date",
"field.course.endDate": "Course End Date",
"field.course.description": "Course Description",
"field.course.price": "Course Price (for this student)",
"field.house.name": "House Name",
"field.house.address": "House Address",
"field.house.owner": "House Owner",
"field.class.name": "Class Name",
"field.class.teacher": "Class Teacher",

// Field Labels - Travel
"field.travel.location": "Travel Location",
"field.travel.address": "Travel Address",
"field.travel.required": "Travel Required",
"field.travel.notes": "Travel Notes",

// Field Labels - Financial
"field.financial.coursePrice": "Course Price (for this student)",
"field.financial.totalPaid": "Total Amount Paid",
"field.financial.balanceDue": "Balance Due",
"field.financial.depositPaid": "Deposit Paid",

// Field Labels - System
"field.system.currentDate": "Current Date",
"field.system.currentYear": "Current Year",
"field.system.collegeName": "College Name",
"field.system.collegeAddress": "College Address",
"field.system.collegePhone": "College Phone",
"field.system.collegeEmail": "College Email",
"dynamicFields.studentInfo": "Student Info",
"dynamicFields.parentInfo": "Parent Info",
"dynamicFields.addressInfo": "Address Info",
"dynamicFields.courseHousing": "Course & Housing",
"dynamicFields.travelInfo": "Travel Info",
"dynamicFields.financialInfo": "Financial Info",
"dynamicFields.systemInfo": "System Info",

// Recipient Selection
"recipients.summary": "selected",
"recipients.filtered": "filtered",
"recipients.total": "total",
"recipients.outOf": "out of",
"recipients.emailTarget": "Emails will be sent to parent addresses",
"recipients.emailTargetStudents": "Emails will be sent to student addresses",
"recipients.searchPlaceholder": "Search name, ID, email...",
"recipients.allCourses": "All courses",
"recipients.allHouses": "All houses",
"recipients.allClasses": "All classes",
"recipients.allYears": "All years",
"recipients.allStatuses": "All statuses",
"recipients.allLocations": "All locations",
"recipients.selectAll": "Select all in filter",
"recipients.noStudents": "No students found",
"recipients.noStudentsMatch": "No students match your search criteria",
"recipients.noStudentsAvailable": "No students available",
"recipients.noEmail": "No email",
"recipients.noAddress": "No address",
"recipients.studentsSelected": "students selected for the email campaign.",
"recipients.loadingStudents": "Loading students...",
"recipients.selectPage": "Select Page",
"recipients.deselectPage": "Deselect Page",
"recipients.selectedAcrossPages": "{{count}} selected across multiple pages",
"recipients.results": "results",
"recipients.matching": "matching filters",
"recipients.selecting": "Selecting...",
"recipients.allOnPageSelected": "All {{count}} students on this page are selected.",
"recipients.selectAllMatchingLink": "Select all {{count}} matching students",
"recipients.cinniriOnly": "Cinnirí Only",
"recipients.nonCinniri": "Non-Cinnirí",
"recipients.alreadySent": "Already Sent",
"recipients.notSentYet": "Not Sent Yet",
"common.error": "Error",
"common.success": "Success",
"common.info": "Info",
"common.saving": "Saving...",
"common.dismiss": "Dismiss",

// Additional Communications Dashboard Keys
"communications.manageEmailsAndDrafts": "Manage emails, drafts, and communication analytics",
"communications.sentEmails": "Sent Emails",
"communications.includesDrafts": "including drafts",
"communications.successfullySent": "successfully sent",
"communications.drafts": "Drafts",
"communications.unsavedEmails": "unsent emails",
"communications.all": "All",
"communications.draft": "Draft",
"communications.createdBy": "Created by",
"communications.updated": "updated",
"communications.notSent": "Not sent",
"communications.noperformanceData": "No performance data",
"communications.editDraft": "Edit Draft",
"communications.deleteDraft": "Delete Draft",
"communications.viewEmail": "View Email",
"communications.moreActions": "More Actions",
"communications.noDraftsFound": "No drafts found",
"communications.noDraftsMatchSearch": "No drafts match your search",
"communications.noDraftsExist": "No drafts exist yet",
"communications.createFirstDraft": "Create First Draft",
"communications.manageEmails": "Manage your email communications",

// 404 Not Found Page
"notFound.title": "Page Not Found",
"notFound.message": "The page you are looking for does not exist or you may not have permission to access it.",
"notFound.backHome": "Back to Dashboard",
"notFound.goBack": "Go Back",
"notFound.systemName": "Coláiste Lurgan Management System",

// 403 Access Denied Page
"accessDenied.title": "Access Denied",
"accessDenied.message": "You don't have permission to view this page. Please contact your administrator if you believe this is an error.",
"accessDenied.permissionsRequired": "Required Permissions",
"accessDenied.userTypeRequired": "Required User Type",
"accessDenied.backHome": "Back to Dashboard",
"accessDenied.goBack": "Go Back",
"accessDenied.contactAdmin": "Contact Administrator",
"accessDenied.currentRole": "Your current role:",

// 500 Server Error Page
"serverError.title": "Server Error",
"serverError.message": "Something went wrong on our end. Please try again in a few moments.",
"serverError.details": "If this problem continues, please contact your system administrator.",
"serverError.tryAgain": "Try Again",
"serverError.backHome": "Back to Dashboard",
"serverError.reportIssue": "Report Issue",

// Network Error Page
"networkError.title": "Connection Problem",
"networkError.message": "Unable to connect to the server. Please check your internet connection.",
"networkError.checkConnection": "Check your internet connection and try again",
"networkError.tryAgain": "Try Again",
"networkError.backHome": "Back to Dashboard",
"networkError.offline": "You appear to be offline",

// Maintenance Mode Page
"maintenance.title": "System Maintenance",
"maintenance.message": "The system is currently undergoing scheduled maintenance.",
"maintenance.details": "We'll be back online shortly. Thank you for your patience.",
"maintenance.estimatedTime": "Estimated completion time",
"maintenance.checkBack": "Please check back later",
"maintenance.emergency": "For urgent matters, contact",

// Bulk Upload
"bulkUpload.title": "Bulk Student Upload",
"bulkUpload.confirmClose": "Are you sure you want to close? Your progress will be lost.",
"bulkUpload.stepProgress": "Step {{current}} of {{total}}",

// Steps
"bulkUpload.steps.upload.title": "Upload File",
"bulkUpload.steps.mapping.title": "Map Fields",
"bulkUpload.steps.preview.title": "Preview",
"bulkUpload.steps.processing.title": "Processing",
"bulkUpload.steps.results.title": "Results",

// Step 1: Upload
"bulkUpload.steps.upload.instructions.title": "Upload Instructions",
"bulkUpload.steps.upload.instructions.csvFormat": "CSV format only (UTF-8 encoding)",
"bulkUpload.steps.upload.instructions.maxSize": "Maximum file size: 10MB",
"bulkUpload.steps.upload.instructions.maxRows": "Maximum rows: 2000 students per upload",
"bulkUpload.steps.upload.instructions.encoding": "Ensure file is UTF-8 encoded",
"bulkUpload.steps.upload.dropzone.title": "Drop CSV file here",
"bulkUpload.steps.upload.dropzone.subtitle": "or click to browse",
"bulkUpload.steps.upload.dropzone.button": "Choose File",
"bulkUpload.steps.upload.fileInfo.size": "File size",
"bulkUpload.steps.upload.fileInfo.rows": "Rows",
"bulkUpload.steps.upload.fileInfo.columns": "Columns",
"bulkUpload.steps.upload.fileInfo.columnsPreview": "Column names",
"bulkUpload.steps.upload.success": "File loaded successfully: {{count}} students ready for upload",
"bulkUpload.steps.upload.next": "Next: Map Fields",

// Step 2: Mapping
"bulkUpload.steps.mapping.instructions.title": "Field Mapping",
"bulkUpload.steps.mapping.instructions.description": "Map your CSV columns to database fields. Required fields are marked with *",
"bulkUpload.steps.mapping.stats.totalColumns": "Total Columns",
"bulkUpload.steps.mapping.stats.mapped": "Mapped",
"bulkUpload.steps.mapping.stats.required": "Required",
"bulkUpload.steps.mapping.table.title": "Column Mapping",
"bulkUpload.steps.mapping.table.csvColumn": "CSV Column",
"bulkUpload.steps.mapping.table.selectField": "Select field...",
"bulkUpload.steps.mapping.table.ignore": "Ignore this column",
"bulkUpload.steps.mapping.resetButton": "Reset to Auto-Detect",
"bulkUpload.steps.mapping.validationErrors": "Please fix these errors",
"bulkUpload.steps.mapping.missingRequired.title": "Missing Required Fields ({{count}})",
"bulkUpload.steps.mapping.next": "Next: Preview Data",

// Step 3: Preview
"bulkUpload.steps.preview.instructions.title": "Preview & Validation",
"bulkUpload.steps.preview.instructions.description": "Review sample data before upload. Students will be created even with warnings - you can fix issues later.",
"bulkUpload.steps.preview.summary.totalStudents": "Total Students",
"bulkUpload.steps.preview.summary.mappedFields": "Mapped Fields",
"bulkUpload.steps.preview.summary.ready": "Ready",
"bulkUpload.steps.preview.summary.hasIssues": "Has Issues",
"bulkUpload.steps.preview.next": "Next: Start Upload",
"bulkUpload.steps.preview.warnings.largeFile": "Large upload: {{count}} students. Processing may take a few minutes.",
"bulkUpload.steps.preview.warnings.emptyColumn": "Column '{{field}}' appears to be empty",
"bulkUpload.steps.preview.table.title": "Data Preview",
"bulkUpload.steps.preview.table.showing": "Showing first {{count}} of {{total}} rows",
"bulkUpload.steps.preview.table.showLess": "Show Less",
"bulkUpload.steps.preview.table.showAll": "+{{count}} more columns",
"bulkUpload.steps.preview.notice.title": "Important",
"bulkUpload.steps.preview.notice.description": "Students will be created even if validation errors occur. Problem records will be flagged for manual review.",
"bulkUpload.steps.preview.processing.title": "Estimated Processing Time",
"bulkUpload.steps.preview.processing.estimate": "Approximately {{seconds}} seconds",
"bulkUpload.steps.preview.startUpload": "Start Upload",

// Step 4: Processing
"bulkUpload.steps.processing.title.uploading": "Uploading File",
"bulkUpload.steps.processing.title.processing": "Processing Students",
"bulkUpload.steps.processing.title.success": "Upload Complete",
"bulkUpload.steps.processing.title.error": "Upload Failed",
"bulkUpload.steps.processing.status.uploading": "Uploading CSV file to server...",
"bulkUpload.steps.processing.status.queued": "Upload queued, waiting to start...",
"bulkUpload.steps.processing.status.starting": "Starting upload processing...",
"bulkUpload.steps.processing.status.processing": "Processing students...",
"bulkUpload.steps.processing.status.completed": "Processing completed successfully!",
"bulkUpload.steps.processing.taskId": "Task ID",
"bulkUpload.steps.processing.error.title": "Upload Failed",
"bulkUpload.steps.processing.info.title": "Processing Your Upload",
"bulkUpload.steps.processing.info.doNotClose": "Please do not close this window",
"bulkUpload.steps.processing.info.validation": "Validating student data and checking for errors",
"bulkUpload.steps.processing.info.flagging": "Flagging records with issues for review",
"bulkUpload.steps.processing.info.payments": "Creating payment records where applicable",
"bulkUpload.steps.processing.success.message": "Upload processing completed! Loading results...",

// Step 5: Results
"bulkUpload.steps.results.subtitle": "Successfully uploaded {{count}} of {{total}} students",
"bulkUpload.steps.results.stats.successful": "Perfect",
"bulkUpload.steps.results.stats.warnings": "With Warnings",
"bulkUpload.steps.results.stats.errors": "With Errors",
"bulkUpload.steps.results.stats.failed": "Failed",
"bulkUpload.steps.results.details.batchId": "Batch ID",
"bulkUpload.steps.results.details.processingTime": "Processing Time",
"bulkUpload.steps.results.details.successRate": "Success Rate",
"bulkUpload.steps.results.issues.title": "Validation Issues",
"bulkUpload.steps.results.issues.showing": "Showing {{count}} of {{total}} issues",
"bulkUpload.steps.results.issues.row": "Row",
"bulkUpload.steps.results.issues.field": "Field",
"bulkUpload.steps.results.issues.severity": "Type",
"bulkUpload.steps.results.issues.message": "Message",
"bulkUpload.steps.results.issues.viewMore": "+{{count}} more issues (view in Issues Manager)",
"bulkUpload.steps.results.nextSteps.title": "Next Steps",
"bulkUpload.steps.results.nextSteps.reviewIssues": "Review students with warnings or errors",
"bulkUpload.steps.results.nextSteps.filterStudents": "Filter students by upload status",
"bulkUpload.steps.results.nextSteps.editStudents": "Edit student records to fix issues",
"bulkUpload.steps.results.nextSteps.resolveIssues": "Mark issues as resolved when fixed",
"bulkUpload.steps.results.perfect.title": "Perfect Upload!",
"bulkUpload.steps.results.perfect.message": "All students were uploaded without any issues.",
"bulkUpload.steps.results.close": "Close",
"bulkUpload.steps.results.error.noResults": "No upload results available",

// Field Names
"bulkUpload.fields.first_name": "First Name",
"bulkUpload.fields.last_name": "Last Name",
"bulkUpload.fields.birthday": "Birthday",
"bulkUpload.fields.gender": "Gender",
"bulkUpload.fields.school": "School",
"bulkUpload.fields.school_year": "School Year",
"bulkUpload.fields.home_county": "County",
"bulkUpload.fields.attended_before": "Attended Before",
"bulkUpload.fields.when_attended": "When Attended",
"bulkUpload.fields.address_1": "Address Line 1",
"bulkUpload.fields.address_2": "Address Line 2",
"bulkUpload.fields.address_3": "Address Line 3",
"bulkUpload.fields.address_4": "Address Line 4",
"bulkUpload.fields.eircode": "Eircode",
"bulkUpload.fields.parent_name": "Parent/Guardian Name",
"bulkUpload.fields.parent_email": "Parent Email",
"bulkUpload.fields.parent_phone": "Parent Phone",
"bulkUpload.fields.travel_required": "Travel Required",
"bulkUpload.fields.travel_location": "Travel Location",
"bulkUpload.fields.course": "Course",
"bulkUpload.fields.is_cinnire": "Cinnire (Leader)",
"bulkUpload.fields.payment_amount": "Payment Amount",
"bulkUpload.fields.payment_date": "Payment Date",
"bulkUpload.fields.payment_status": "Payment Status",
"bulkUpload.fields.transaction_id": "Transaction ID",
"bulkUpload.fields.notes": "Notes",

// Errors
"bulkUpload.errors.invalidFileType": "Invalid file type. Please upload a CSV file.",
"bulkUpload.errors.fileTooLarge": "File is too large ({{size}}MB). Maximum size is 10MB.",
"bulkUpload.errors.tooManyRows": "CSV contains {{count}} rows. Maximum allowed is {{max}} rows.",
"bulkUpload.errors.emptyFile": "CSV file is empty.",
"bulkUpload.errors.noColumns": "CSV file has no columns.",
"bulkUpload.errors.parseError": "Failed to parse CSV: {{message}}",
"bulkUpload.errors.requiredFieldMissing": "Required field '{{field}}' is not mapped",
"bulkUpload.errors.duplicateMapping": "Field '{{field}}' is mapped multiple times",
"bulkUpload.errors.uploadFailed": "Upload failed. Please try again.",
"bulkUpload.errors.statusCheckFailed": "Failed to check upload status.",
"bulkUpload.errors.processingFailed": "Upload processing failed.",

// Friendships
"friendships.title": "Friends",
"friendships.addFriend": "Add Friend",
"friendships.addFriendTitle": "Add Friend",
"friendships.addFriendDescription": "Select a student to add as a friend. Students must be in the same course and same gender.",
"friendships.removeFriendTitle": "Remove Friend",
"friendships.removeFriendDescription": "Are you sure you want to remove {{name}} as a friend?",
"friendships.searchPlaceholder": "Search by name or student ID...",
"friendships.typeToSearch": "Type to search for students",
"friendships.typeToSearchDescription": "Enter at least 2 characters to start searching",
"friendships.noEligibleStudents": "No eligible students found",
"friendships.noFriends": "No friends yet",
"friendships.noFriendsDescription": "Click 'Add Friend' to create friendship groups",
"friendships.comingSoon": "Friendship groups coming soon",
"friendships.countOfMax": "{{count}} of {{max}}",
"friendships.removeAlsoUnlinked": "{{names}} will also no longer be linked to this student.",
"friendships.directFriend": "Direct Friend",
"friendships.transitiveFriend": "Transitive Friend",
"friendships.groupFull": "Group is full (maximum 3 students)",
"friendships.groupFullTitle": "Maximum Group Size Reached",
"friendships.groupFullDescription": "This student is already in a full friendship group. Remove a friend before adding a new one.",
"friendships.adding": "Adding...",
"friendships.removing": "Removing...",
"friendships.removeFriend": "Remove Friend",
"friendships.addSuccess": "Friend added successfully",
"friendships.addSuccessDescription": "The friendship has been created",
"friendships.addError": "Failed to add friend",
"friendships.addErrorTitle": "Error Adding Friend",
"friendships.removeSuccess": "Friend removed successfully",
"friendships.removeSuccessDescription": "{{name}} has been removed from the friends list",
"friendships.removeError": "Failed to remove friend",
"friendships.removeErrorTitle": "Error Removing Friend",
"friendships.warningLabel": "Warning:",
"friendships.removeWarning": "This will break the friendship connection and may affect house assignments.",
"friendships.loadError": "Failed to load friendships",
"friendships.addedToGroup": "{{name}} has been added to the friend group",
"friendships.housePromptSubtitle": "Friend added — housing assignment",
"friendships.housePromptTitle": "{{name}} isn't in {{house}} yet. Move them there now?",
"friendships.currentlyIn": "Currently assigned to {{house}} — they will be reassigned",
"friendships.houseFull": "{{house}} is full — no space for this student",
"friendships.houseFullHint": "Assign them manually from the House Allocation page once space is available",
"friendships.skipHouseAssign": "Skip for now",
"friendships.moveToHouse": "Move to {{house}}",
"friendships.movedToHouse": "Moved to {{house}}",

// Payments Panel
"payments.title": "Payments",
"payments.addPayment": "Add Payment",
"payments.addPaymentTitle": "Add Payment",
"payments.addPaymentDescription": "Record a new payment for this student",
"payments.editPaymentTitle": "Edit Payment",
"payments.editPaymentDescription": "Update payment details",
"payments.deletePaymentTitle": "Delete Payment",
"payments.deletePaymentDescription": "Are you sure you want to delete this payment?",
"payments.deletePayment": "Delete Payment",
"payments.deleteWarning": "This action cannot be undone. The payment record will be permanently removed.",
"payments.noPayments": "No payments recorded",
"payments.noPaymentsDescription": "Add the first payment to track finances",
"payments.paymentHistory": "Payment History",
"payments.loadError": "Failed to load payments",

// Payment Summary
"payments.summary.coursePrice": "Course Price",
"payments.summary.additionalCharges": "Additional Charges",
"payments.summary.travel": "Travel",
"payments.summary.totalPaid": "Total Paid",
"payments.summary.balanceDue": "Balance Due",
"payments.balanceNote": "The options to pay the balance of fees will be available in January 2027.",
"payments.summary.status": "Status",
"payments.summary.fullyPaid": "Fully Paid",
"payments.summary.outstanding": "Outstanding",
"payments.summary.overpaid": "Overpaid",

// Payment Types
"payments.type.DEPOSIT": "Deposit",
"payments.type.BALANCE": "Balance",
"payments.type.REFUND": "Refund",
"payments.type.ADJUSTMENT": "Adjustment",
"payments.type.SCHOLARSHIP": "Scholarship",

// Payment Statuses
"payments.status.PENDING": "Pending",
"payments.status.PROCESSING": "Processing",
"payments.status.COMPLETED": "Completed",
"payments.status.FAILED": "Failed",
"payments.status.CANCELLED": "Cancelled",
"payments.status.REFUNDED": "Refunded",

// Payment Methods
"payments.method.STRIPE": "Stripe (Online)",
"payments.method.CARD": "Credit/Debit Card",
"payments.method.BANK_TRANSFER": "Bank Transfer",
"payments.method.CASH": "Cash",
"payments.method.CHEQUE": "Cheque",
"payments.method.OTHER": "Other",

// Scholarship
"payments.scholarship.provider": "Scholarship Provider",
"payments.scholarship.providerPlaceholder": "e.g., Department of Education",
"payments.scholarship.type": "Scholarship Type",
"payments.scholarship.selectType": "Select type",
"payments.scholarship.FULL": "Full Scholarship",
"payments.scholarship.PARTIAL": "Partial Scholarship",
"payments.scholarship.reference": "Scholarship Reference",
"payments.scholarship.referencePlaceholder": "Reference number or code",

// Payment Form
"payments.form.paymentType": "Payment Type",
"payments.form.selectType": "Select payment type",
"payments.form.amount": "Amount (EUR)",
"payments.form.paymentMethod": "Payment Method",
"payments.form.paymentDate": "Payment Date",
"payments.form.status": "Status",
"payments.form.referenceNumber": "Reference Number",
"payments.form.referencePlaceholder": "e.g., INV-2026-001",
"payments.form.notes": "Notes",
"payments.form.notesPlaceholder": "Additional notes about this payment...",
"payments.form.adding": "Adding...",
"payments.form.saving": "Saving...",
"payments.form.deleting": "Deleting...",
"payments.form.saveChanges": "Save Changes",

// Payment Toast Messages
"payments.toast.addSuccess": "Payment Added",
"payments.toast.addSuccessDescription": "The payment has been recorded successfully",
"payments.toast.addError": "Failed to add payment",
"payments.toast.addErrorTitle": "Error Adding Payment",
"payments.toast.updateSuccess": "Payment Updated",
"payments.toast.updateSuccessDescription": "The payment has been updated successfully",
"payments.toast.updateError": "Failed to update payment",
"payments.toast.updateErrorTitle": "Error Updating Payment",
"payments.toast.deleteSuccess": "Payment Deleted",
"payments.toast.deleteSuccessDescription": "The payment has been removed",
"payments.toast.deleteError": "Failed to delete payment",
"payments.toast.deleteErrorTitle": "Error Deleting Payment",

// Payments Page & Bulk Upload
"payments.status.ERROR": "Error",
"payments.page.description": "Review flagged payments and import payment CSV files",
"payments.page.searchResults": "{{count}} result(s) for \"{{term}}\"",
"payments.page.flaggedCount": "{{count}} flagged payment(s) requiring attention",
"payments.page.flaggedTitle": "Flagged Payments",
"payments.page.uploadCsv": "Upload CSV",
"payments.page.showErrors": "Show Errors",
"payments.page.hideErrors": "Hide Errors",
"payments.page.searchPlaceholder": "Search by name, ID, email or reference...",
"payments.page.loading": "Loading payments...",
"payments.page.error": "Failed to load payments",
"payments.page.noFlagged": "No flagged payments — all clear",
"payments.page.noResults": "No payments found",
"payments.page.unmatched": "Unmatched",
"payments.page.col.date": "Date",
"payments.page.col.student": "Student",
"payments.page.col.amount": "Amount",
"payments.page.col.type": "Type",
"payments.page.col.method": "Method",
"payments.page.col.status": "Status",
"payments.page.col.flag": "Flag",
"payments.page.col.reference": "Reference",
"payments.upload.title": "Import Payment CSV",
"payments.upload.step1Title": "Upload",
"payments.upload.step2Title": "Preview",
"payments.upload.step3Title": "Done",
"payments.upload.selectFile": "Select CSV file",
"payments.upload.dragDrop": "Drag & drop or click to select",
"payments.upload.fileRequired": "Please select a CSV file",
"payments.upload.paymentMethod": "Payment method",
"payments.upload.paymentMethodHint": "The method used for all payments in this file",
"payments.upload.previewButton": "Preview",
"payments.upload.previewing": "Previewing...",
"payments.upload.confirmClose": "Discard upload and close?",
"payments.upload.previewError": "Failed to parse CSV — please check the file format",
"payments.upload.noReady": "No payments ready to import",
"payments.upload.noFlagged": "No flagged payments",
"payments.upload.noUnmatched": "No unmatched payments",
"payments.upload.unmatchedWillSave": "{{count}} unmatched payment(s) will be saved",
"payments.upload.unmatchedSaveExplain": "Unmatched payments are saved without a student link so nothing is lost. You can assign them later from the Payments page.",
"payments.upload.importAllButton": "Import {{count}} payment",
"payments.upload.importAllButton_plural": "Import {{count}} payments",
"payments.upload.importing": "Importing...",
"payments.upload.errorTitle": "Import failed",
"payments.upload.successTitle": "Import complete",
"payments.upload.travelUpdated": "{{count}} student marked as travel required",
"payments.upload.travelUpdated_plural": "{{count}} students marked as travel required",
"payments.upload.skipped": "{{count}} row skipped",
"payments.upload.skipped_plural": "{{count}} rows skipped",
"payments.upload.doneButton": "Done",
"payments.upload.col.student": "Student",
"payments.upload.col.studentId": "ID",
"payments.upload.col.amount": "Amount",
"payments.upload.col.balanceDue": "Balance Due",
"payments.upload.col.date": "Date",
"payments.upload.col.flag": "Flag",
"payments.upload.col.matchMethod": "Matched by",
"payments.upload.col.reason": "Reason",
"payments.upload.flag.travel_flag": "Travel",
"payments.upload.flag.overpayment": "Overpayment",
"payments.upload.flag.potential_duplicate": "Potential Duplicate",
"payments.upload.flag.unmatched": "Unmatched",
"payments.upload.flag.travel_flag_action": "Importing will mark this student as requiring travel ({{travel}})",
"payments.upload.flag.overpayment_action": "Payment exceeds balance due by {{excess}}",
"payments.upload.flag.overpayment_travel_mismatch": "Excess ({{excess}}) doesn't match travel price ({{travel}}) — may be a data error",
"payments.upload.flag.potential_duplicate_action": "A payment of the same amount already exists for this student on this date",
"payments.upload.match.student_id": "Registration No.",
"payments.upload.match.email": "Email",
"payments.upload.match.name": "Name",
"payments.resolve.title": "Resolve Payment",
"payments.resolve.assignStudent": "Assign to student",
"payments.resolve.searchStudents": "Search students...",
"payments.resolve.markResolved": "Mark as Resolved",
"payments.resolve.resolvedSuccess": "Payment resolved",
"payments.resolve.keepPayment": "Keep as is",
"payments.resolve.keptSuccess": "Payment kept",
"payments.resolve.markError": "Mark as Error",
"payments.resolve.markErrorConfirm": "This will soft-delete the payment. Are you sure?",
"payments.resolve.travelNote": "Resolving will mark this student as travel required",
"payments.resolve.duplicateNote": "This looks like a duplicate — verify before keeping",
"payments.resolve.duplicateKeepNote": "Keeping this will flag the student account for manual review",
"payments.flag.travel_flag": "Travel",
"payments.flag.overpayment": "Overpayment",
"payments.flag.potential_duplicate": "Potential Duplicate",
"payments.flag.unmatched": "Unmatched",

"auditLog.title": "Audit Log",
"auditLog.description": "Security and activity audit trail — ADMIN only",
"auditLog.filter.studentPlaceholder": "Search student...",
"auditLog.filter.noStudents": "No students found",
"auditLog.filter.userPlaceholder": "Filter by email...",
"auditLog.filter.dateFrom": "From",
"auditLog.filter.dateTo": "To",
"auditLog.col.timestamp": "Time",
"auditLog.col.user": "User",
"auditLog.col.action": "Action",
"auditLog.col.description": "Description",
"auditLog.col.object": "Object",
"auditLog.col.ip": "IP",
"auditLog.system": "System",
"auditLog.loading": "Loading audit log...",
"auditLog.loadError": "Failed to load audit log",
"auditLog.noEntries": "No entries found",
"auditLog.noEntriesDescription": "No audit log entries match the current filters",
"auditLog.entries": "entries",
"auditLog.pagination": "Page {{page}} of {{totalPages}}",

"payments.tab.overview": "Overview",
"payments.tab.flagged": "Flagged",
"payments.overview.activeSummary": "{{students}} active students — {{paid}} fully paid, {{balance}} with balance",
"payments.overview.addPayment": "Add Payment",
"payments.overview.totalCollected": "Total Collected",
"payments.overview.totalOutstanding": "Total Outstanding",
"payments.overview.collectionRate": "Collection Rate",
"payments.overview.flagged": "Flagged",
"payments.overview.students": "students",
"payments.overview.fullyPaid": "fully paid",
"payments.overview.withBalance": "with balance",
"payments.overview.viewStudents": "View students",
"payments.overview.requireAttention": "requiring attention",
"payments.overview.allClear": "all clear",
"payments.overview.byType": "By Payment Type",
"payments.overview.byMethod": "By Method",
"payments.overview.noData": "No payment data",
"payments.overview.selectStudent": "Select Student",
"payments.overview.searchStudent": "Search by name or student ID...",
"payments.overview.noStudents": "No students found",
"payments.overview.loading": "Loading...",

"common.remove": "Remove",

// Student Detail Page - Section Titles
"students.detail.personalInfo": "Personal Information",
"students.detail.academicInfo": "Academic Information",
"students.detail.travelLeadership": "Travel & Leadership",
"students.detail.notes": "Notes",
"students.detail.parentGuardian": "Parent/Guardian Contact",
"students.detail.address": "Address",
"students.detail.travel": "Travel",

// Common Values
"common.yes": "Yes",
"common.no": "No",
"common.male": "Male",
"common.female": "Female",
"common.other": "Other",
"common.none": "None",
"common.cinnire": "Cinnire",
"common.notSpecified": "Not specified",
"common.notProvided": "Not provided",
"common.noDetailsProvided": "No details provided",
"common.noNotesAvailable": "No notes available",
"common.warning": "Warning",
"common.optional": "optional",

// Form Placeholders
"placeholders.firstName": "First name",
"placeholders.lastName": "Last name",
"placeholders.selectGender": "Select gender",
"placeholders.selectCourse": "Select course",
"placeholders.selectSchoolYear": "Select school year",
"placeholders.selectTravelLocation": "Select travel location",
"placeholders.county": "County",
"placeholders.schoolName": "School name",
"placeholders.parentGuardianName": "Parent/Guardian name",
"placeholders.phoneNumber": "Phone number",
"placeholders.addressLine1": "Address line 1",
"placeholders.addressLine2": "Address line 2",
"placeholders.addressLine3": "Address line 3",
"placeholders.addressLine4": "Address line 4",
"placeholders.eircode": "Eircode",
"placeholders.addNotes": "Add notes about the student..."
    ,

// Added missing translations
"communications.dashboard": "Communications Dashboard",
"communications.emailDashboard": "Email Dashboard",
"communications.overview": "Overview",
"communications.viewAnalytics": "View Analytics",
"communications.recentEmails": "Recent Emails",
"communications.totalSent": "Total Sent",
"communications.clickRate": "Click Rate",
"communications.bounceRate": "Bounce Rate",
"communications.createFirst": "Create First Email",
"email.create": "Create Email",
"campaign.basicInfo": "Basic Information",
"campaign.content": "Content",
"campaign.preview": "Preview",
"campaign.settings": "Settings",
"campaign.name": "Campaign Name",
"campaign.type": "Campaign Type",
"campaign.editContent": "Edit Content",
"campaign.previewEmail": "Preview Email",
"campaign.sendTest": "Send Test",
"campaign.send": "Send",
"campaign.saveDraft": "Save Draft",
"campaign.schedule": "Schedule",
"campaign.selectRecipients": "Select Recipients",
"campaign.insertField": "Insert Field",
"campaign.dynamicFields": "Dynamic Fields",
"campaign.emailLayout": "Email Layout",
"campaignType.welcome": "Welcome",
"campaignType.reminder": "Reminder",
"campaignType.announcement": "Announcement",
"campaignType.newsletter": "Newsletter",
"campaignType.marketing": "Marketing",
"campaignType.other": "Other",
"campaignStatus.draft": "Draft",
"campaignStatus.scheduled": "Scheduled",
"campaignStatus.sending": "Sending",
"campaignStatus.sent": "Sent",
"campaignStatus.failed": "Failed",
"campaignStatus.cancelled": "Cancelled",
"recipients.title": "Recipients",
"recipients.selected": "Selected",
"recipients.selectedCount": "Selected Count",
"recipients.totalStudents": "Total Students",
"paymentStatus.paid": "Paid",
"paymentStatus.partial": "Partial",
"paymentStatus.pending": "Pending",
"paymentStatus.overdue": "Overdue",
// Export
"export.button": "Export",
"export.title": "Export Students",
"export.description": "Select fields to export for {{count}} students",
"export.selectedCount": "{{selected}} of {{total}} fields selected",
"export.selectAll": "Select All",
"export.deselectAll": "Deselect All",
"export.noFieldsSelected": "Please select at least one field to export",
"export.exporting": "Exporting...",
"export.exportCSV": "Export CSV",
"export.success": "Successfully exported {{count}} students",
"export.error": "Export failed. Please try again.",
"export.sensitive": "🔒",

// Export Field Groups
"export.groups.administrative": "Administrative",
"export.groups.personal": "Personal Information",
"export.groups.contact": "Contact Details",
"export.groups.address": "Address Information",
"export.groups.academic": "Academic Details",
"export.groups.travel": "Travel Information",
"export.groups.financial": "Financial Information",
"export.groups.leadership": "Leadership",
"export.groups.friendship": "Friendship Groups",
"export.groups.notes": "Notes",
"export.groups.other": "Other Fields",

// Export Field Labels - Administrative
"export.fields.student_id": "Unique ID",
"export.fields.status": "Enrollment Status",
"export.fields.upload_status": "Upload Status",
"export.fields.upload_issues": "Upload Issues",

// Export Field Labels - Personal
"export.fields.photo_url": "Profile Photo",
"export.fields.first_name": "First Name",
"export.fields.last_name": "Last Name",
"export.fields.birthday": "Date of Birth",
"export.fields.age": "Age",
"export.fields.gender": "Gender",
"export.fields.home_county": "County",

// Export Field Labels - Contact
"export.fields.parent_name": "Parent/Guardian Name",
"export.fields.parent_email": "Parent/Guardian Email",
"export.fields.parent_phone": "Parent/Guardian Phone",

// Export Field Labels - Address
"export.fields.address_1": "Address Line 1",
"export.fields.address_2": "Address Line 2",
"export.fields.address_3": "Address Line 3",
"export.fields.address_4": "Address Line 4",
"export.fields.eircode": "Eircode",

// Export Field Labels - Academic
"export.fields.course": "Course",
"export.fields.house": "House",
"export.fields.class_group": "Class Group",
"export.fields.school": "School",
"export.fields.school_year": "School Year",
"export.fields.interview_score": "Interview Score",
"export.fields.interview_notes": "Interview Notes",
"export.fields.attended_before": "Previously Attended",
"export.fields.when_attended": "When Attended",

// Export Field Labels - Travel
"export.fields.travel_required": "Travel Required",
"export.fields.travel_location": "Travel Location",

// Export Field Labels - Financial
"export.fields.total_paid": "Total Amount Paid",
"export.fields.balance_due": "Outstanding Balance",

// Export Field Labels - Leadership
"export.fields.is_cinnire": "Cinnire (Leader)",
"export.fields.oide_username": "Assigned Staff Member",

// Export Field Labels - Friendship
"export.fields.has_friends": "Has Friends",
"export.fields.friend_1_id": "Friend 1 Student ID",
"export.fields.friend_1_name": "Friend 1 Name",
"export.fields.friend_2_id": "Friend 2 Student ID",
"export.fields.friend_2_name": "Friend 2 Name",

// Export Field Labels - Notes
"export.fields.notes": "Notes",

// Navigation
"nav.houseAllocation": "House Allocation",
"nav.cuntoirs": "Cúntóirí",

// Cúntóirí Management
"cuntoirs.title": "Cúntóirí",
"cuntoirs.description": "Manage summer supervisors and allocate them to houses",
"cuntoirs.addCuntoir": "Add Cúntóir",
"cuntoirs.uploadCsv": "Upload CSV",
"cuntoirs.name": "Name",
"cuntoirs.email": "Email",
"cuntoirs.gender": "Gender",
"cuntoirs.course": "Course",
"cuntoirs.house": "House",
"cuntoirs.unassigned": "Unassigned",
"cuntoirs.noData": "No Cúntóirí uploaded yet",
"cuntoirs.deleteConfirm": "Are you sure you want to delete this Cúntóir?",
"cuntoirs.csvInstructions": "Required columns: first_name, last_name, gender (M/F). Optional: email, course (abbreviation or name).",
"cuntoirs.upload.instructions.title": "Upload Instructions",
"cuntoirs.upload.instructions.required": "Required columns: first_name, last_name, gender (M/F, Male/Female, Buachaill/Cailín)",
"cuntoirs.upload.instructions.optional": "Optional columns: email, course (use course abbreviation or full name)",
"cuntoirs.upload.instructions.csvFormat": "CSV format only (UTF-8 encoding)",
"cuntoirs.upload.instructions.allCourses": "All courses can be in a single file — use the course column to assign each row",
"cuntoirs.selectCourse": "Select course",
"cuntoirs.uploadSuccess": "Cúntóirí uploaded",
"cuntoirs.uploadSuccessDesc": "{{count}} Cúntóir(í) added successfully",
"cuntoirs.created": "Cúntóir added",
"cuntoirs.deleted": "Cúntóir deleted",
"cuntoirs.updated": "Cúntóir updated",
"cuntoirs.fields.first_name": "First Name",
"cuntoirs.fields.last_name": "Last Name",
"cuntoirs.fields.gender": "Gender",
"cuntoirs.fields.email": "Email",
"cuntoirs.fields.course": "Course",

// House Settings
"houseSettings.title": "House Settings",
"houseSettings.description": "Manage houses and set capacity and gender designation per course.",
"houseSettings.addHouse": "Add House",
"houseSettings.saveAll": "Save All",
"houseSettings.saveChanges": "Save Changes",
"houseSettings.discardChanges": "Discard Changes",
"houseSettings.pendingChanges_one": "{{count}} unsaved change",
"houseSettings.pendingChanges_other": "{{count}} unsaved changes",
"houseSettings.house": "House",
"houseSettings.capacity": "Capacity",
"houseSettings.full": "Full",
"houseSettings.gender": "Gender",
"houseSettings.maxCapacity": "Max",
"houseSettings.male": "Male",
"houseSettings.female": "Female",
"houseSettings.maleAbbr": "M",
"houseSettings.femaleAbbr": "F",
"houseSettings.editHouse": "Edit House",
"houseSettings.deleteTitle": "Delete House",
"houseSettings.deleteConfirm": "This will permanently remove {{name}}. Are you sure?",
"houseSettings.deleteSuccess": "House deleted",
"houseSettings.houseOwner": "House Owner",
"houseSettings.ownerName": "Owner Name",
"houseSettings.ownerEmail": "Owner Email",
"houseSettings.ownerEmailHint": "A new account will be created if this email is not registered.",
"houseSettings.address": "Address",
"houseSettings.eircode": "Eircode",
"houseSettings.mobile": "Mobile",
"houseSettings.landline": "Landline",
"houseSettings.name": "House Name",
"houseSettings.active": "Active",
"houseSettings.inactive": "Inactive",
"houseSettings.saveSuccess": "Capacity saved",
"houseSettings.houseCreated": "House created",
"houseSettings.houseCreatedDesc": "{{name}} has been added",
"houseSettings.houseUpdated": "House updated",
"houseSettings.houseUpdatedDesc": "{{name}} has been saved",
"houseSettings.houseActivated": "{{name}} is now active",
"houseSettings.houseDeactivated": "{{name}} is now inactive",
"houseSettings.deleteSuccessDesc": "{{name}} has been removed",
"houseSettings.saveError": "Failed to save house",
"houseSettings.updateCoursesTitle": "Update Course Capacities",
"houseSettings.updateCoursesDesc": "Max capacity changed from {{old}} to {{new}} for {{name}}. Would you like to update all course capacities to {{new}} as well?",
"houseSettings.updateCoursesConfirm": "Update All Courses",
"houseSettings.updateCoursesSkip": "Keep Existing",
"houseSettings.deleteError": "Failed to delete house",
"houseSettings.noUpcomingCourses": "No upcoming courses found.",
"houseSettings.noHouses": "No houses added yet.",
"houseSettings.summary": "Summary",
"houseSettings.totalBeds": "total beds",
"houseSettings.enrolled": "enrolled",
"houseSettings.beds": "beds",

// House Allocation Kanban
"houseAllocation.title": "House Allocation",
"houseAllocation.description": "Assign students to houses by dragging them into a house column.",
"houseAllocation.selectCourse": "Select a course to begin",
"houseAllocation.unassigned": "Unassigned",
"houseAllocation.students": "Students",
"houseAllocation.cinnire": "Cinnirí",
"houseAllocation.cuntoir": "Cúntóirí",
"houseAllocation.searchStudents": "Search...",
"houseAllocation.male": "Male",
"houseAllocation.female": "Female",
"houseAllocation.capacity": "{{current}} / {{max}}",
"houseAllocation.full": "Full",
"houseAllocation.readOnlyBanner": "You are viewing house allocations in read-only mode.",
"houseAllocation.friendGroupMoved": "Friend group assigned ({{count}} students)",
"houseAllocation.friendGroupMovedDesc": "All members of the friend group have been moved together.",
"houseAllocation.error.genderMismatch": "Wrong gender for this house",
"houseAllocation.error.genderMismatchDesc": "This house is designated for the other gender. Please choose a matching house.",
"houseAllocation.error.capacityExceeded": "House is full",
"houseAllocation.error.capacityExceededDesc": "There are not enough spaces in this house for this student or group.",
"houseAllocation.noStudents": "No unassigned students",
"houseAllocation.clearAll": "Clear All Assignments",
"houseAllocation.clearAllConfirm": "This will remove all house assignments for this course. Are you sure?",
"houseAllocation.clearedAll": "All assignments cleared",
"houseAllocation.maleHouses": "Male Houses",
"houseAllocation.femaleHouses": "Female Houses",
"houseAllocation.noAssigned": "No students assigned",
"houseAllocation.progress": "{{assigned}} / {{total}} students assigned",
"houseAllocation.total": "Total",
"houseAllocation.selectCoursePrompt": "Select a course to begin allocating students to houses.",
"houseAllocation.allCourses": "All Courses",
"houseAllocation.complete": "Complete",
"houseAllocation.houseCount": "{{count}} houses",
"houseAllocation.clearAcknowledge": "I understand this will permanently remove all house assignments for this course",
"houseAllocation.clearPassword": "Confirm your password",
"houseAllocation.clearPasswordPlaceholder": "Enter your password",
"houseAllocation.clearPasswordError": "Incorrect password",
"houseAllocation.clearedAllCount": "{{count}} student(s) have been removed from their houses.",
"houseAllocation.clearError": "Something went wrong while clearing assignments. Please try again.",
"houseAllocation.clearMale": "Clear Male Assignments",
"houseAllocation.clearFemale": "Clear Female Assignments",
"houseAllocation.clearMaleConfirm": "This will remove all male house assignments for this course. Are you sure?",
"houseAllocation.clearFemaleConfirm": "This will remove all female house assignments for this course. Are you sure?",
"houseAllocation.filterAllYears": "All years",
"houseAllocation.crossYearFriend": "Cross-year friend",
"students.tabs.profile": "Profile",
"students.tabs.housing": "Housing",
"students.tabs.friends": "Friends",
"students.tabs.interview": "Interview",
"students.tabs.payments": "Payments",
"students.tabs.notes": "Notes",
"students.housing.currentAssignment": "House Assignment",
"students.class.currentAssignment": "Class Assignment",
"students.class.unassigned": "Unassigned",
"students.class.changeClass": "Change Class",
"students.class.remove": "Remove",
"students.class.removeGroup": "Remove group",
"students.class.selectPrompt": "Select a class to assign this student.",
"students.class.moveSuccess": "Assigned to {{class}}",
"students.class.unassignSuccess": "Removed from class",
"students.class.moveError": "Failed to assign class",
"students.housing.unassigned": "Unassigned",
"students.housing.changeHouse": "Change House",
"students.housing.remove": "Remove",
"students.housing.removeGroup": "Remove group",
"students.housing.groupGenderWarning": "Some group members have different genders and cannot be assigned to this house.",
"students.housing.selectPrompt": "Select a house for this student:",
"students.housing.groupMoveConfirm": "This will move the whole group ({{count}} students) to {{house}}.",
"students.housing.groupUnassignConfirm": "This will unassign the whole group ({{count}} students).",
"students.housing.groupMembers": "Group",
"students.housing.moveSuccess": "House assigned",
"students.housing.unassignSuccess": "Student unassigned",
"students.housing.groupMovedDesc": "{{count}} students moved to {{house}}",
"students.housing.moveError": "Could not update house assignment",
"students.housing.errorCapacity": "Not enough space — the house doesn't have room for the whole group",
"students.housing.errorGender": "Gender mismatch — students cannot be assigned to this house",
"students.housing.friendGroup": "Friend Group",
"students.housing.groupTogether": "Together",
"students.housing.groupSplit": "Split",
"students.housing.youSuffix": "(you)",

"emailLog.title": "Email History",
"emailLog.noEmails": "No emails have been sent to this student.",
"emailLog.columns.sentAt": "Date Sent",
"emailLog.columns.subject": "Subject",
"emailLog.columns.type": "Type",
"emailLog.columns.parentEmail": "Parent Email",
"emailLog.columns.status": "Status",
"emailLog.columns.sentBy": "Sent By",
"emailLog.status.SENT": "Sent",
"emailLog.status.DELIVERED": "Delivered",
"emailLog.status.OPENED": "Opened",
"emailLog.status.PENDING": "Pending",
"emailLog.status.FAILED": "Failed",
"emailLog.status.BOUNCED": "Bounced",
"emailLog.status.DRAFT": "Draft",

"linkedHistory.title": "Linked History",
"linkedHistory.columns.course": "Course",
"linkedHistory.columns.schoolYear": "School Year",
"linkedHistory.columns.status": "Status",
"linkedHistory.columns.parent": "Parent",
"linkedHistory.columns.parentEmail": "Parent Email",

// Class Allocation Kanban
"nav.classAllocation": "Class Allocation",
"classAllocation.title": "Class Allocation",
"classAllocation.description": "Assign students to class groups by dragging them into a class.",
"classAllocation.selectCoursePrompt": "Select a course to begin allocating students to classes.",
"classAllocation.allCourses": "All Courses",
"classAllocation.unassigned": "Unassigned",
"classAllocation.searchStudents": "Search...",
"classAllocation.filterByYear": "Year",
"classAllocation.filterAllYears": "All Years",
"classAllocation.noStudents": "No unassigned students",
"classAllocation.noAssigned": "No students assigned",
"classAllocation.students": "Students",
"classAllocation.cinnire": "Cinnirí",
"classAllocation.total": "Total",
"classAllocation.complete": "Complete",
"classAllocation.classes": "Classes",
"classAllocation.studentsAssigned": "Students assigned",
"classAllocation.full": "Full",
"classAllocation.cinnireClass": "Cinnirí Class",
"classAllocation.classCount": "{{count}} classes",
"classAllocation.assigned": "{{assigned}} / {{total}} assigned",
"classAllocation.autoAssign": "Auto-Assign",
"classAllocation.autoAssigning": "Assigning...",
"classAllocation.autoAssignConfirm": "Auto-assign will fill unassigned students into classes, respecting school year groups, gender balance (70/30), house spread, and friend groups.",
"classAllocation.autoAssignReassignAll": "Reassign all students (overrides any manual assignments)",
"classAllocation.autoAssignSuccess": "{{count}} students assigned to classes",
"classAllocation.autoAssignError": "Auto-assign failed. Please try again.",
"classAllocation.exportCsv": "Export Class Lists",
"classAllocation.teacher": "Teacher",
"classAllocation.noTeacher": "No teacher assigned",
"classAllocation.teacherAssignError": "Failed to assign teacher. Please try again.",
"classAllocation.renameClass": "Click to rename",
"classAllocation.print": "Print Class Lists",
"classAllocation.printedOn": "Printed: {{date}}",
"classAllocation.clearAll": "Clear All Assignments",
"classAllocation.clearConfirm": "This will remove all class group assignments for this course. Are you sure?",
"classAllocation.clearAcknowledge": "I understand this will permanently remove all class assignments for this course",
"classAllocation.clearPassword": "Confirm your password",
"classAllocation.clearPasswordPlaceholder": "Enter your password",
"classAllocation.clearPasswordError": "Incorrect password",
"classAllocation.clearedAll": "All assignments cleared",
"classAllocation.clearedAllCount": "{{count}} student(s) have been removed from their classes.",
"classAllocation.clearError": "Something went wrong while clearing assignments. Please try again.",
"classAllocation.friendGroupMoved": "Friend group assigned ({{count}} students)",
"classAllocation.friendGroupMovedDesc": "All members of the friend group have been moved together.",
"classAllocation.error.capacityExceeded": "Class is full",
"classAllocation.error.capacityExceededDesc": "There are not enough spaces in this class for this student or group.",
"classAllocation.error.cinnireOnly": "Cinnirí class restriction",
"classAllocation.error.cinnireOnlyDesc": "Only Cinnirí students can be placed in the Cinnirí class.",
"classAllocation.error.cinnireMustGoToClass": "Cinnirí must use Cinnirí class",
"classAllocation.error.cinnireMustGoToClassDesc": "This student is a Cinnire and can only be assigned to the dedicated Cinnirí class.",

"footer.builtBy": "Built by",

"impersonation.banner": "Viewing as {{name}}",
"impersonation.readOnly": "read-only mode",
"impersonation.stop": "Stop Impersonating",
"impersonation.start": "Impersonate User",
"impersonation.errorTitle": "Impersonation Failed",

"teacherDashboard.myClasses": "My Classes",
"teacherDashboard.myClassesSubtitle": "Students assigned to your classes for upcoming courses",
"teacherDashboard.noClassesForCourse": "You have no classes assigned for this course",
"teacherDashboard.noStudentsInClass": "No students assigned to this class",
"dashboard.classGroups": "Class Groups",
"dashboard.viewAllocationBoard": "View Allocation Board",

"houseOwnerDashboard.title": "My Houses",
"houseOwnerDashboard.subtitle": "Your houses for upcoming courses",
"houseOwnerDashboard.totalHouses": "My Houses",
"houseOwnerDashboard.assigned": "Assigned",
"houseOwnerDashboard.unplaced": "Unplaced",
"houseOwnerDashboard.noHouses": "No houses assigned to you yet",
"houseOwnerDashboard.noHousesDescription": "Contact an administrator to be linked to your houses.",
"houseOwnerDashboard.places": "places",
"houseOwnerDashboard.allCourses": "All Courses",
"houseOwnerDashboard.studentDetailsNotAvailable": "Student details will be available 2 days before the course begins.",
"houseOwnerDashboard.noStudents": "No students assigned yet",
"houseOwnerDashboard.name": "Name",
"houseOwnerDashboard.year": "Year",
"houseOwnerDashboard.county": "County",
"houseOwnerDashboard.parentPhone": "Phone",
"houseOwnerDashboard.parentEmail": "Email",

// GDPR Cookie Consent
"gdpr.banner.title": "We use cookies",
"gdpr.banner.description": "We use essential cookies to keep you logged in and optional preference cookies to remember your settings.",
"gdpr.banner.privacyLink": "Privacy Policy",
"gdpr.banner.acceptAll": "Accept All",
"gdpr.banner.reject": "Reject Optional",
"gdpr.banner.settings": "Settings",
"gdpr.settings.title": "Cookie Settings",
"gdpr.settings.essential.title": "Essential Cookies",
"gdpr.settings.essential.description": "Required for login and security. Cannot be disabled.",
"gdpr.settings.functional.title": "Preference Cookies",
"gdpr.settings.functional.description": "Remember your language choice and saved form settings. The site works without these.",
"gdpr.settings.acceptAll": "Accept All",
"gdpr.settings.rejectAll": "Reject Optional",
"gdpr.settings.save": "Save Preferences",
"gdpr.footer.cookieSettings": "Cookie Settings",
"gdpr.footer.privacyPolicy": "Privacy Policy",
"gdpr.privacy.lastUpdated": "Last updated"
};

export default enTranslations;
